import React, {useCallback, useEffect, useState} from "react";
import {Modal, Button, Form, Dropdown, Col, Image, Card, ListGroup, Table, Alert} from "react-bootstrap";
import { toast } from "react-toastify";
import {editAssignment, editAssignmentAdmin, fetchAssignmentsAdmin, fetchUserDataById} from "../../http/bookAPI";

import Row from "react-bootstrap/Row";
import {FaBookOpen, FaCoins, FaMoneyBillWave, FaSearchDollar, FaTasks,} from "react-icons/fa";
import {FaStackExchange} from "react-icons/fa6";
import {fetchAssignLogs, fetchUserLogs, getLinkedByUserApi} from "../../http/userLogAPI";
import {
    getRedirectUrlApi,
    updateAssignmentAuthorDataFront,
    updateAssignmentReviewerDataFront,
    updateUserDataAdminFront,
    userBalanceChangeApi,
} from "../../http/userAPI";
import AmazonReviewParserExt from "../assignmentpages/AmazonReviewParserExt";
import AmazonReviewLinkStaffEditor from "./AmazonReviewLinkStaffEditor";
import AdminAmazonReviewParserExt from "./AdminAmazonReviewParserExt";
import AudibleReviewParser from "../assignmentpages/AudibleReviewParser";
import ProofImageCard from "../common/ProofImageCard";
import ImageLightbox from "../common/ImageLightbox";

const statusOptions = ["NEW", "READING", "READING_RIDT", "READING_RE", "REPORTED", "REPORTED_RFU", "REPORTED_RV", "SUCCESS", "SUSPENDED", "ADM_CANCEL"];
const readingStep = ["STEP1", "STEP2", "STEP3", "STEP4", "STEP5", "NO_STEP"];
const userStatusOptions = ["FREE", "ESSENTIAL", "PREMIUM", "MAXIMUM", "SUSPENDED"];
const amazonSites = [
    { code: "US", url: "https://www.amazon.com", label: "Amazon USA" },
    { code: "UK", url: "https://www.amazon.co.uk", label: "Amazon UK" },
    { code: "CA", url: "https://www.amazon.ca", label: "Amazon Canada" },
    { code: "DE", url: "https://www.amazon.de", label: "Amazon Germany" },
    { code: "FR", url: "https://www.amazon.fr", label: "Amazon France" },
    { code: "IT", url: "https://www.amazon.it", label: "Amazon Italy" },
    { code: "ES", url: "https://www.amazon.es", label: "Amazon Spain" },
    { code: "JP", url: "https://www.amazon.co.jp", label: "Amazon Japan" },
    { code: "AU", url: "https://www.amazon.com.au", label: "Amazon Australia" },
    { code: "IN", url: "https://www.amazon.in", label: "Amazon India" },
    { code: "MX", url: "https://www.amazon.com.mx", label: "Amazon Mexico" },
    { code: "BR", url: "https://www.amazon.com.br", label: "Amazon Brazil" },
    { code: "CN", url: "https://www.amazon.cn", label: "Amazon China" },
];
const audibleSites = [
    { code: "AUS", url: "https://www.audible.com", label: "Audible USA" },
    { code: "AUK", url: "https://www.audible.co.uk", label: "Audible UK" },
];
const DUAL_PROOF_REQUIRED_ASS_TYPES = [10,11,14,15,18,19,20,21,22,23,24,27];
const SINGLE_PROOF_REQUIRED_ASS_TYPES = [28,29,30,31,32];
const PROOF_REQUIRED_ASS_TYPES = [
    ...DUAL_PROOF_REQUIRED_ASS_TYPES,
    ...SINGLE_PROOF_REQUIRED_ASS_TYPES,
];

const isProofRequiredAssignment = (assTypeId) => PROOF_REQUIRED_ASS_TYPES.includes(Number(assTypeId));

const getAssignmentBookAsin = (assignment) => {
    const book = assignment?.book;
    if (!book) return "";
    const assTypeId = Number(assignment?.assTypeId);
    if (assTypeId === 32) return book.kindle_asin || "";
    if (Number(assignment?.booksTypeId) === 2) return book.paper_back_asin || book.kindle_asin || "";
    if (Number(assignment?.booksTypeId) === 3) return book.hard_cover_asin || book.paper_back_asin || book.kindle_asin || "";
    if (Number(assignment?.booksTypeId) === 4) return book.audio_asin || book.audio_audible_asin || book.kindle_asin || "";
    return book.kindle_asin || book.paper_back_asin || book.hard_cover_asin || book.audio_asin || book.audio_audible_asin || "";
};

const getExpectationByType = (assTypeId) => {
    // Покупка/ребейт и промо-покупки — ждём Verified Purchase
    if ([3, 5, 9, 10, 11, 14, 15].includes(Number(assTypeId))) {
        return "Verified Purchase Review";
    }
    if ([4, 6, 12, 16].includes(Number(assTypeId))) {
        return "Verified Purchase Review with Photos";
    }
    if ([13, 17].includes(Number(assTypeId))) {
        return "Verified Purchase Review with Video";
    }
    // Универсальные/прочие
    if ([28, 30].includes(Number(assTypeId))) {
        return "Helpful vote screenshot";
    }
    if ([29, 31].includes(Number(assTypeId))) {
        return "Report screenshot";
    }
    if (Number(assTypeId) === 32) {
        return "Star rating screenshot";
    }
    if ([1, 2, 7, 8].includes(Number(assTypeId))) {
        return "Non-Verified Review";
    }
    // Фоллбек
    return "Verified Purchase Review";
};

const getExpectedReviewerNameForAssignment = (assignment) => {
    if (Number(assignment?.assTypeId) === 8) {
        return assignment?.reviewer_audible_name_snapshot || assignment?.reviewer_name || "";
    }

    return assignment?.reviewer_amazon_name_snapshot || assignment?.reviewer_name || "";
};

const EditAssignmentAdmin = ({
    show,
    handleClose,
    initialAssignmentFromTable,
    statusin,
    stepin,
    onOpenBookAssignments,
    onOpenUserAuthorAssignments,
    onOpenUserReviewerAssignments,
}) => {
    // 1) Хуки всегда сверху
    const [assignmentData, setAssignmentData] = useState(() => initialAssignmentFromTable || null);
    const [loading, setLoading] = useState(false);
    const expect = getExpectationByType(assignmentData?.assTypeId)
    const expectedReviewerName = getExpectedReviewerNameForAssignment(assignmentData);
    const id = initialAssignmentFromTable?.id ?? assignmentData?.id ?? null;
    const [linked, setLinked] = useState(null);     // полный ответ сервера
    const [linkedLoading, setLinkedLoading] = useState(false);
    const [linkedError, setLinkedError] = useState(null);


    // refetch всегда с актуальным id
    const refetchAssignment = useCallback(async () => {
        if (!id) return;
        setLoading(true);
        try {
            const resp = await fetchAssignmentsAdmin({ assignment_id: id, page: 1, limit: 1 });
            const next = resp?.items?.[0] || resp?.rows?.[0] || resp?.list?.[0] || null;
            if (next) setAssignmentData(next);
        } finally {
            setLoading(false);
        }
    }, [id]);

    // 👇 синхронизация по "идентификатору", а не по ссылке объекта
    useEffect(() => {
        if (!show) return;
        setAssignmentData(initialAssignmentFromTable || null);
        if (initialAssignmentFromTable?.id) {
            refetchAssignment();
        }
    }, [show, initialAssignmentFromTable?.id, refetchAssignment]); // важен .id


    const [selectedStatus, setSelectedStatus] = useState(assignmentData?.assignment_status || "NEW");
    const [currentStep, setCurrentStep] = useState(assignmentData?.reviewer_reading_step || "NO_STEP");
    const [logs, setLogs] = useState([]);
    const [error, setError] = useState(null);
    const [authorAmount, setAuthorAmount] = useState('');
    const [reviewerAmount, setReviewerAmount] = useState('');
    const [reviewData, setReviewData] = useState(null);
    const [ownerData, setOwnerData] = useState(null);
    const [reviewerData, setReviewerData] = useState(null);
    const [messageS, setMessageS] = useState("");
    const [loadingId, setLoadingId] = useState(null);
    const [showAuthorEditor, setShowAuthorEditor] = useState(false);
    const [showReviewerEditor, setShowReviewerEditor] = useState(false);
    const [fullImage, setFullImage] = useState(null);
    const emptyUserEditor = {
        tariff_plan: "",
        amz_name: "",
        amz_country: "",
        audible_name: "",
        audible_country: "",
        amazon_rn_changes: 0,
        audible_rn_changes: 0,
        virt: 0,
        trust: 0,
        usd: 0,
        aff: 0,
        message: "",
    };
    const [authorEditor, setAuthorEditor] = useState(emptyUserEditor);
    const [reviewerEditor, setReviewerEditor] = useState(emptyUserEditor);

    const openRedirectedLink = async (link) => {
        if (!link) return;
        try {
            const response = await getRedirectUrlApi(link);
            if (!response?.redirectUrl) throw new Error("Redirect URL missing");
            window.open(response.redirectUrl, "_blank", "noopener,noreferrer");
        } catch (err) {
            console.error("Redirect error:", err);
        }
    };

    const authorBalanceChange = async (id, authorBalanceChange) => {
        try {
            await updateAssignmentAuthorDataFront(
                assignmentData.id,
                authorBalanceChange,
                `Support Change Your Balance: ${authorBalanceChange} Virt. Book: ${assignmentData?.book?.title}`
            );
            alert(`Author balance updated by ${authorBalanceChange} Virt`);
        } catch (error) {
            console.error("Error updating author data:", error);
            alert('Error updating author balance');
        }
    };

    useEffect(() => {
        if (!show) return; // срабатываем только при открытой модалке
        const status = (statusin ?? assignmentData?.assignment_status ?? "NEW");
        const step = (stepin ?? assignmentData?.reviewer_reading_step ?? "NO_STEP");
        setSelectedStatus(status);
        setCurrentStep(step);
    }, [show, statusin, stepin, assignmentData?.assignment_status, assignmentData?.reviewer_reading_step]);

    const makeUserEditor = (data) => ({
        tariff_plan: data?.tariff_plan || "",
        amz_name: data?.amz_name || "",
        amz_country: data?.amz_country || "",
        audible_name: data?.audible_name || "",
        audible_country: data?.audible_country || "",
        amazon_rn_changes: data?.amazon_rn_changes || 0,
        audible_rn_changes: data?.audible_rn_changes || 0,
        virt: 0,
        trust: 0,
        usd: 0,
        aff: 0,
        message: "",
    });

    useEffect(() => {
        if (!show) return;
        setAuthorEditor(makeUserEditor(ownerData || assignmentData?.owner));
    }, [show, ownerData?.userId, assignmentData?.owner?.id]);

    useEffect(() => {
        if (!show) return;
        setReviewerEditor(makeUserEditor(reviewerData || assignmentData?.reviewer));
    }, [show, reviewerData?.userId, assignmentData?.reviewer?.id]);

    const reviewerBalanceChange = async (id, reviewerBalanceChange) => {
        try {
            await updateAssignmentReviewerDataFront(
                assignmentData.id,
                reviewerBalanceChange,
                `Support Change Your Balance: ${reviewerBalanceChange} Virt. Book: ${assignmentData?.book?.title}`
            );
            alert(`Reviewer balance updated by ${reviewerBalanceChange} Virt`);
        } catch (error) {
            console.error("Error updating reviewer data:", error);
            alert('Error updating reviewer balance');
        }
    };

    const handleClick = () => {
        const isAuthorValid = authorAmount !== '' && !isNaN(authorAmount);
        const isReviewerValid = reviewerAmount !== '' && !isNaN(reviewerAmount);

        if (!isAuthorValid && !isReviewerValid) {
            alert("Please enter a valid amount in at least one field.");
            return;
        }

        if (isAuthorValid) {
            authorBalanceChange(assignmentData.id, parseFloat(authorAmount));
        }

        if (isReviewerValid) {
            reviewerBalanceChange(assignmentData.id, parseFloat(reviewerAmount));
        }

        setAuthorAmount('');
        setReviewerAmount('');
    };

    const getLinked = async (userToCheckId) => {
        try {
            setLoadingId(`fraud:${userToCheckId}`);
            setLinkedError(null);
            setLogs([]);

            const resp = await getLinkedByUserApi(userToCheckId, {
                lookbackDays: 90,
                minSignals: 2,
                includeGuests: false,
                excludeNulls: true,
                page: 1,
                limit: 50,
            });

            setLinked(resp);
            if ((resp?.total_matches ?? 0) === 0) {
                toast.info("No linked accounts found in the selected window.", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                setMessageS("No Fraud Activity Detected")
            } else {
                const n = resp?.total_matches ?? 0;
                if (n > 1) {
                    setMessageS(`⚠️ Attention: ${n} linked accounts detected. Please review carefully.`);
                } else if (n === 1) {
                    setMessageS("⚠️ Attention: 1 linked account detected. Please review carefully.");
                } else {
                    setMessageS("No linked accounts found.");
                }
            }
        } catch (e) {
            const msg = e?.response?.data?.message || "Failed to fetch linked accounts";
            setLinkedError(msg);
            toast.error(msg, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
        } finally {
            setLoadingId(null);   // сбрасываем
        }
    };

    const internalhandleClose = () => {
        setSelectedStatus("");
        setCurrentStep("");
        handleClose();
        setLogs([]);
        setReviewData(null);
        setOwnerData(null);
        setReviewerData(null);
        setAssignmentData({});
        setMessageS("");
        // + NEW
        setLinked(null);
        setLinkedError(null);
        setLinkedLoading(false);
        setShowAuthorEditor(false);
        setShowReviewerEditor(false);
    }

    const getLogs = async () => {
        try {
            setLoadingId("allLogs");
            const logs = await fetchAssignLogs(assignmentData.id, 300); // или assignmentData.id
            setLogs(logs); // см. следующий шаг

        } catch (error) {
            console.error('Error fetching logs:', error);
        } finally {
            setLoadingId(null);
        }
    };

    const getALogs = async () => {
       setLogs([]);
        setLinked(null);
        setLinkedError(null);
        setLinkedLoading(false);
        try {
            setLoadingId("authorLogs");
            const logs = await fetchUserLogs(assignmentData.userId, 200); // или assignmentData.id
            setLogs(logs); // см. следующий шаг
        } catch (error) {
            console.error('Error fetching logs:', error);
        } finally {
            setLoadingId(null);
        }
    };

    const getRLogs = async () => {
        setLogs([]);
        setLinked(null);
        setLinkedError(null);
        setLinkedLoading(false);
        try {
            setLoadingId("reviewerLogs");
            const logs = await fetchUserLogs(assignmentData.reviewer_id, 200); // или assignmentData.id
            setLogs(logs); // см. следующий шаг
        } catch (error) {
            console.error('Error fetching logs:', error);
        } finally {
            setLoadingId(null);
        }
    };

    const clearLogs = async () => {
        setLogs([]);
        setLinked(null);
        setMessageS("");
        setLinkedError(null);
        setLinkedLoading(false);

    }

    const closeAndOpenSearch = (handler, value) => {
        const targetValue = value ? String(value) : "";
        internalhandleClose();
        if (targetValue && typeof handler === "function") {
            handler(targetValue);
        }
    };

    const hostFromUrl = (u) => {
        if (!u) return "";
        try {
            return new URL(u).host;
        } catch {
            return String(u).replace(/^https?:\/\//, "").split("/")[0];
        }
    };

    const formatUserDate = (minutes) => {
        if (!minutes && minutes !== 0) return "—";
        return new Date(Number(minutes) * 60000).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        });
    };

    const renderUserSummaryCard = (title, data, roleId) => (
        <Card className="border border-secondary mb-2">
            <Card.Body className="py-2">
                <div className="small text-muted lh-sm">
                    <span className="fw-semibold text-dark">{title} ID: {roleId || data?.userId || data?.id || "—"}</span>
                    {" / "}<span className="fw-semibold text-dark">{data?.username || "—"}</span>
                    {" / "}<span className="fw-semibold text-dark">{data?.email || "—"}</span>
                    {" / AMZ: "}<span className="fw-semibold text-dark">{data?.amz_name || "—"} | {data?.audible_name || "—"}</span>
                    {" / Plan: "}<span className="fw-semibold text-dark">{data?.tariff_plan || "—"}</span>
                    {" / Balance: "}<span className="fw-semibold text-dark">{data?.balance ?? "—"} Virt | ${data?.lr_balance ?? "0.00"}</span>
                    {" / Trust: "}<span className="fw-semibold text-dark">{data?.level_of_trust ?? "—"}</span>
                    {" / Country: "}<span className="fw-semibold text-dark">{hostFromUrl(data?.amz_country) || "—"} | {hostFromUrl(data?.audible_country) || "—"}</span>
                    {" / Assignments: "}<span className="fw-semibold text-dark">Post: {data?.postedAss ?? "—"} | Took: {data?.compiledAss ?? "—"}</span>
                    {" / Registered: "}<span className="fw-semibold text-dark">{formatUserDate(data?.registration_date)}</span>
                </div>
            </Card.Body>
        </Card>
    );
    Boolean(renderUserSummaryCard);

    const refreshAssignmentUsers = async () => {
        try {
            if (assignmentData?.userId) setOwnerData(await fetchUserDataById(assignmentData.userId));
            if (assignmentData?.reviewer_id) setReviewerData(await fetchUserDataById(assignmentData.reviewer_id));
        } catch (error) {
            console.error("Assignment users refresh failed:", error);
        }
    };

    const saveUserProfileChanges = async (userId, editor, label) => {
        if (!userId) return;
        try {
            await updateUserDataAdminFront({
                id: userId,
                tariff_plan: editor.tariff_plan,
                amz_name: editor.amz_name,
                amz_country: editor.amz_country,
                audible_name: editor.audible_name,
                audible_country: editor.audible_country,
                amazon_rn_changes: editor.amazon_rn_changes,
                audible_rn_changes: editor.audible_rn_changes,
            });
            toast.success(`${label} updated!`, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            await refreshAssignmentUsers();
        } catch (error) {
            toast.error(`Failed to update ${label.toLowerCase()}`, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            console.error(`${label} update failed:`, error);
        }
    };

    const saveUserBalanceChanges = async (userId, editor, setEditor, label) => {
        if (!userId) return;
        const virtAmount = Number(editor.virt) || 0;
        const usdAmount = Number(editor.usd) || 0;
        const trustAmount = Number(editor.trust) || 0;
        const affAmount = Number(editor.aff) || 0;
        const hasAnyValue = [virtAmount, usdAmount, trustAmount, affAmount].some((v) => !Number.isNaN(v) && v !== 0);
        if (!hasAnyValue) {
            toast.info("Please enter at least one non-zero value", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            return;
        }
        try {
            const response = await userBalanceChangeApi(userId, virtAmount, usdAmount, trustAmount, affAmount, editor.message);
            toast.info(response?.message || `${label} balance updated`, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            setEditor((prev) => ({ ...prev, virt: 0, usd: 0, trust: 0, aff: 0, message: "" }));
            await refreshAssignmentUsers();
        } catch (error) {
            toast.error(error?.response?.data?.message || `Failed to change ${label.toLowerCase()} balance`, {
                position: "bottom-center",
                autoClose: 3000,
                hideProgressBar: false,
            });
            console.error(`${label} balance update failed:`, error);
        }
    };

    const renderUserPanel = ({ title, data, roleId, showEditor, setShowEditor, editor, setEditor }) => {
        const userId = roleId || data?.userId || data?.id;
        return (
            <Card className="border border-secondary mb-2">
                <Card.Body className="py-2">
                    <div className="d-flex align-items-center justify-content-between gap-2">
                        <div className="small text-muted lh-sm flex-grow-1">
                            <span className="fw-semibold text-dark">{title} ID: {userId || "—"}</span>
                            {" / "}<span className="fw-semibold text-dark">{data?.username || "—"}</span>
                            {" / "}<span className="fw-semibold text-dark">{data?.email || "—"}</span>
                            {" / AMZ: "}<span className="fw-semibold text-dark">{data?.amz_name || "—"} | {data?.audible_name || "—"}</span>
                            {" / Plan: "}<span className="fw-semibold text-dark">{data?.tariff_plan || "—"}</span>
                            {" / Balance: "}<span className="fw-semibold text-dark">{data?.balance ?? "—"} Virt | ${data?.lr_balance ?? "0.00"}</span>
                            {" / Trust: "}<span className="fw-semibold text-dark">{data?.level_of_trust ?? "—"}</span>
                            {" / Country: "}<span className="fw-semibold text-dark">{hostFromUrl(data?.amz_country) || "—"} | {hostFromUrl(data?.audible_country) || "—"}</span>
                            {" / Assignments: "}<span className="fw-semibold text-dark">Post: {data?.postedAss ?? "—"} | Took: {data?.compiledAss ?? "—"}</span>
                            {" / Registered: "}<span className="fw-semibold text-dark">{formatUserDate(data?.registration_date)}</span>
                        </div>
                        <Button
                            type="button"
                            variant={showEditor ? "success" : "outline-success"}
                            size="sm"
                            className="text-nowrap"
                            onClick={() => setShowEditor((v) => !v)}
                        >
                            {showEditor ? `Hide ${title} Edit` : `${title} Edit`}
                        </Button>
                    </div>

                    {showEditor && (
                        <div className="border-top mt-2 pt-2">
                            <Row className="g-2 align-items-end">
                                <Col xs={12} md={2}>
                                    <Form.Label className="small mb-1">Amazon Reviewer</Form.Label>
                                    <Form.Control size="sm" className="border-secondary" value={editor.amz_name} onChange={(e) => setEditor((p) => ({ ...p, amz_name: e.target.value }))} />
                                </Col>
                                <Col xs={12} md={2}>
                                    <Form.Label className="small mb-1">Amazon Site</Form.Label>
                                    <Form.Select size="sm" className="border-secondary" value={editor.amz_country} onChange={(e) => setEditor((p) => ({ ...p, amz_country: e.target.value }))}>
                                        <option value="">Amazon Site</option>
                                        {amazonSites.map((site) => <option key={site.code} value={site.url}>{site.label}</option>)}
                                    </Form.Select>
                                </Col>
                                <Col xs={12} md={1}>
                                    <Form.Label className="small mb-1">RN Attempts</Form.Label>
                                    <Form.Select size="sm" className="border-secondary" value={editor.amazon_rn_changes} onChange={(e) => setEditor((p) => ({ ...p, amazon_rn_changes: Number(e.target.value) }))}>
                                        {[0, 1, 2, 3].map((num) => <option key={num} value={num}>{num}</option>)}
                                    </Form.Select>
                                </Col>
                                <Col xs={12} md={1}>
                                    <Form.Label className="small mb-1">Plan</Form.Label>
                                    <Form.Select size="sm" className="border-secondary" value={editor.tariff_plan} onChange={(e) => setEditor((p) => ({ ...p, tariff_plan: e.target.value }))}>
                                        <option value="">Plan</option>
                                        {userStatusOptions.map((item) => <option key={item} value={item}>{item}</option>)}
                                    </Form.Select>
                                </Col>
                                <Col xs={12} md={1}>
                                    <Form.Label className="small mb-1">Audible Rw</Form.Label>
                                    <Form.Control size="sm" className="border-secondary" value={editor.audible_name} onChange={(e) => setEditor((p) => ({ ...p, audible_name: e.target.value }))} />
                                </Col>
                                <Col xs={12} md={2}>
                                    <Form.Label className="small mb-1">Audible Site</Form.Label>
                                    <Form.Select size="sm" className="border-secondary" value={editor.audible_country} onChange={(e) => setEditor((p) => ({ ...p, audible_country: e.target.value }))}>
                                        <option value="">Audible Site</option>
                                        {audibleSites.map((site) => <option key={site.code} value={site.url}>{site.label}</option>)}
                                    </Form.Select>
                                </Col>
                                <Col xs={12} md={1}>
                                    <Form.Label className="small mb-1">RN Attempts</Form.Label>
                                    <Form.Select size="sm" className="border-secondary" value={editor.audible_rn_changes} onChange={(e) => setEditor((p) => ({ ...p, audible_rn_changes: Number(e.target.value) }))}>
                                        {[0, 1, 2, 3].map((num) => <option key={num} value={num}>{num}</option>)}
                                    </Form.Select>
                                </Col>
                                <Col xs={12} md={2} className="d-flex justify-content-md-end">
                                    <Button type="button" variant="outline-success" size="sm" className="text-nowrap" onClick={() => saveUserProfileChanges(userId, editor, title)}>
                                        Apply Changes
                                    </Button>
                                </Col>
                                <Col xs={12} className="small text-muted text-nowrap overflow-auto">
                                    User ID: <span className="fw-semibold">{userId}</span>, AN: <span className="fw-semibold">{data?.amz_name || "—"}</span>
                                    {" | "}Virt: <span className="fw-semibold">{Number(parseFloat(data?.balance) || 0).toFixed(0)}</span>,
                                    USD: <span className="fw-semibold"> ${Number(parseFloat(data?.lr_balance) || 0).toFixed(2)}</span>,
                                    Trust: <span className="fw-semibold"> {data?.level_of_trust ?? "—"}</span>,
                                    Aff: <span className="fw-semibold"> ${Number(parseFloat(data?.affiliate_balance) || 0).toFixed(2)}</span>
                                </Col>
                            </Row>
                            <Row className="g-2 align-items-end mt-1">
                                {[
                                    ["virt", "Virt"],
                                    ["trust", "Trust"],
                                    ["usd", "USD"],
                                    ["aff", "Aff USD"],
                                ].map(([key, label]) => (
                                    <Col xs={6} md={1} key={key}>
                                        <Form.Label className="small mb-1">{label}</Form.Label>
                                        <Form.Control type="number" size="sm" value={editor[key]} onChange={(e) => setEditor((p) => ({ ...p, [key]: e.target.value }))} />
                                    </Col>
                                ))}
                                <Col xs={12} md={6}>
                                    <Form.Label className="small mb-1">Message</Form.Label>
                                    <Form.Control type="text" size="sm" value={editor.message} onChange={(e) => setEditor((p) => ({ ...p, message: e.target.value }))} />
                                </Col>
                                <Col xs={12} md={2} className="d-flex justify-content-md-end">
                                    <Button type="button" variant="outline-success" size="sm" className="text-nowrap" onClick={() => saveUserBalanceChanges(userId, editor, setEditor, title)}>
                                        Apply Changes
                                    </Button>
                                </Col>
                            </Row>
                        </div>
                    )}
                </Card.Body>
            </Card>
        );
    };

    const nowMinutes = () => Math.floor(Date.now() / 60000);

    const handleSaveChanges = async () => {
        try {
            const updatedData = {
                id: assignmentData.id,
                assignment_status: selectedStatus,
                end_rev_date: nowMinutes(),
                reviewer_reading_step: currentStep,

            };

            if (selectedStatus === "SUCCESS") {
                updatedData.checked_asin = assignmentData?.checked_asin || getAssignmentBookAsin(assignmentData);
                updatedData.checked_review_name = expectedReviewerName;
                updatedData.publish_rev_date = nowMinutes();
            }

            const resp = await editAssignmentAdmin(updatedData);



            // Универсальный геттер сообщения от сервера (успех)
            const serverMsg =
                resp?.data?.message ||      // axios: { data: { message } }
                resp?.message ||            // fetch-обёртка: { message }
                `Assignment updated to "${selectedStatus}" (step: ${currentStep}).`;

            toast.success(serverMsg, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            setMessageS(serverMsg);
        } catch (error) {
            // Универсальный геттер сообщения об ошибке
            const errMsg =
                error?.response?.data?.message || // axios: { response: { data: { message } } }
                error?.response?.data?.error ||   // иногда сервер шлёт { error }
                error?.message ||                 // JS Error message
                "Failed to update assignment";

            toast.error(errMsg, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            console.error("Error updating assignment:", error);
        }
    };

    const handleProofApprove = async () => {
        const checkedAsin = assignmentData?.checked_asin || getAssignmentBookAsin(assignmentData);
        if (!checkedAsin) {
            toast.error("Cannot approve proof: ASIN is missing for this assignment.", {
                position: "bottom-center",
                autoClose: 3000,
                hideProgressBar: false,
            });
            return;
        }

        try {
            setLoading(true);
            const resp = await editAssignmentAdmin({
                id: assignmentData.id,
                staff_proof_action: "approve",
                assignment_status: "SUCCESS",
                reviewer_reading_step: "STEP5",
                checked_asin: checkedAsin,
                checked_review_name: expectedReviewerName,
                publish_rev_date: nowMinutes(),
                end_rev_date: nowMinutes(),
            });

            const serverMsg = resp?.data?.message || resp?.message || "Proof approved. Assignment moved to SUCCESS / STEP5.";
            toast.success(serverMsg, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            setMessageS(serverMsg);
            if (resp?.assignment) setAssignmentData(resp.assignment);
            await refetchAssignment();
        } catch (error) {
            const errMsg =
                error?.response?.data?.message ||
                error?.response?.data?.error ||
                error?.message ||
                "Failed to approve proof.";
            toast.error(errMsg, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            console.error("Error approving proof:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleProofReject = async () => {
        if (!window.confirm("Reject this proof, debit reviewer Virt/bonus, and reopen the assignment?")) {
            return;
        }

        try {
            setLoading(true);
            const resp = await editAssignmentAdmin({
                id: assignmentData.id,
                staff_proof_action: "reject",
            });

            const serverMsg = resp?.data?.message || resp?.message || "Proof rejected. Assignment reopened.";
            toast.success(serverMsg, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            setMessageS(serverMsg);
            if (resp?.assignment) setAssignmentData(resp.assignment);
            await refetchAssignment();
        } catch (error) {
            const errMsg =
                error?.response?.data?.message ||
                error?.response?.data?.error ||
                error?.message ||
                "Failed to reject proof.";
            toast.error(errMsg, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            console.error("Error rejecting proof:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleConfirmNoReview = async () => {
        // 🔹 Определяем checkedAsin с учётом типов 28–31
        let checkedAsin;

        if ([28, 29, 30, 31, 32].includes(assignmentData?.assTypeId)) {
            // 🟢 Берём первый непустой ASIN среди всех возможных типов
            checkedAsin =
                assignmentData?.book?.kindle_asin ||
                assignmentData?.book?.paper_back_asin ||
                assignmentData?.book?.hard_cover_asin ||
                assignmentData?.book?.audible_asin ||
                assignmentData?.book?.audio_asin ||
                undefined;
        } else {
            // 🟡 Обычная логика по booksTypeId
            checkedAsin =
                assignmentData?.booksTypeId === 2
                    ? assignmentData?.book?.paper_back_asin
                    : assignmentData?.booksTypeId === 3
                        ? assignmentData?.book?.hard_cover_asin
                        : assignmentData?.book?.kindle_asin; // можно явно вернуть kindle_asin как дефолт
        }

        try {
            // 🟢 Определяем, нужно ли включать review_link
            const shouldIncludeReviewLink = ![28, 29, 30, 31, 32].includes(assignmentData?.assTypeId);

            const updatedData = {
                id: assignmentData.id,
                assignment_status: 'SUCCESS',
                end_rev_date: nowMinutes(),
                reviewer_reading_step: 'STEP5',
                checked_asin: checkedAsin,
                checked_review_name: reviewerData?.amz_name,
                ...(shouldIncludeReviewLink && { review_link: reviewerData?.amz_country }),
            };

            const resp = await editAssignmentAdmin(updatedData);



            // Универсальный геттер сообщения от сервера (успех)
            const serverMsg =
                resp?.data?.message ||      // axios: { data: { message } }
                resp?.message ||            // fetch-обёртка: { message }
                `Updated to "SUCCESS" (STEP5)`;

            toast.success(serverMsg, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            setMessageS(serverMsg);
        } catch (error) {
            // Универсальный геттер сообщения об ошибке
            const errMsg =
                error?.response?.data?.message || // axios: { response: { data: { message } } }
                error?.response?.data?.error ||   // иногда сервер шлёт { error }
                error?.message ||                 // JS Error message
                "Failed to update assignment";

            toast.error(errMsg, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            console.error("Error updating assignment:", error);
        }
    };

    const handleDecline = async () => {
        try {
            const updatedData = {
                id: assignmentData.id,
                assignment_status: 'READING',
                start_rev_date: nowMinutes(),
                reviewer_reading_step: 'STEP2',
            };

            const resp = await editAssignmentAdmin(updatedData);

            // Универсальный геттер сообщения от сервера (успех)
            const serverMsg =
                resp?.data?.message ||      // axios: { data: { message } }
                resp?.message ||            // fetch-обёртка: { message }
                `Assignment updated to "READING" (STEP2).`;

            toast.success(serverMsg, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            setMessageS(serverMsg);
        } catch (error) {
            // Универсальный геттер сообщения об ошибке
            const errMsg =
                error?.response?.data?.message || // axios: { response: { data: { message } } }
                error?.response?.data?.error ||   // иногда сервер шлёт { error }
                error?.message ||                 // JS Error message
                "Failed to update assignment";

            toast.error(errMsg, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            console.error("Error updating assignment:", error);
        }
    };

    useEffect(() => {
        if (!show || !assignmentData?.id || !assignmentData?.userId) return;

        const fetchUsersDataById = async () => {
            setLoading(true);
            setError(null);
            try {
                const response_owner = await fetchUserDataById (assignmentData?.userId);
                setOwnerData(response_owner);
                const response_reviewer = await fetchUserDataById (assignmentData?.reviewer_id);
                setReviewerData(response_reviewer);
            } catch (err) {
                setError(err.message || "User data loading Error");
            } finally {
                setLoading(false);
            }
        };
        fetchUsersDataById();
    }, [show, assignmentData?.id,]);

    const handleExtractAudibleReview = async (data) => {
        setReviewData(data);
        const expectedReviewAsin = assignmentData.book_asin || "";
        const expectedReviewerName = reviewerData?.audible_name || "";
        const expectedRating = initialAssignmentFromTable?.rating || 0;

        if (data.asin !== expectedReviewAsin ||
            data.listener_name !== expectedReviewerName ||
            Number(data.overall_rating) !== Number(expectedRating)) {
            setCurrentStep("STEP4");
            // ✅ Выводим тост об ошибке
            toast.error("Verification Failed! Check Rating, Reviewer Name or Asin.", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            await editAssignment({
                id: initialAssignmentFromTable?.id,
                review_link: data.review_link,
                checked_asin: data.asin,
                checked_review_name: data.listener_name,
                checked_review_rating: data.overall_rating,
                checked_story_rating: data.story_rating,
                checked_performance_rating: data.performance_rating,

            });
        } else {
            await editAssignment({
                id: initialAssignmentFromTable?.id,
                reviewer_reading_step: 'STEP5',
                assignment_status: 'SUCCESS',
                review_link: data.review_link,
                end_rev_date: Math.floor(Date.now() / 1000 / 60),
                checked_asin: data.asin,
                checked_review_name: data.listener_name,
                checked_review_title: data.review_title,
                checked_review_text: data.review_text,
                checked_review_rating: data.overall_rating,
                checked_story_rating: Number(data.story_rating),
                checked_performance_rating: data.performance_rating,
                checked_review_country: reviewerData?.audible_country,
                checked_review_date: data.review_date,
                checked_proxy_country: data.proxy_country,

            });

            // ✅ Выводим тост об успешной проверке
            toast.success("Verification Review Link Successful!", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
        }



    };

    // ==== helpers (положи выше return) ====
    const BOOK_TYPE_LABEL = { 1: "Kindle", 2: "Paperback", 3: "Hardcover", 4: "Audio" };

    const getExpectedAsinByType = (booksTypeId, book) => {
        if (!book) return null;
        switch (booksTypeId) {
            case 1: return book.kindle_asin || null;
            case 2: return book.paper_back_asin || null;
            case 3: return book.hard_cover_asin || null;
            case 4: return book.audio_asin || book.audio_audible_asin || null;
            case 5: return "Not Need";
            case 6: return "Not Need";
            case 7: return book.kindle_asin || null;
            case 8: return book.paper_back_asin || null;
            case 9: return book.hard_cover_asin || null;
            case 10: return book.audio_asin || null;
            default: return null;
        }
    };

    const isAsinOfThisBook = (asin, book) => {
        if (!asin || !book) return false;
        const list = [
            book.kindle_asin,
            book.paper_back_asin,
            book.hard_cover_asin,
            book.audio_asin,
            book.audio_audible_asin,
        ].filter(Boolean);
        return list?.includes(asin);
    };

    const normalize = (s) =>
        (s || "")
            .normalize("NFKD")
            .replace(/\p{M}/gu, "")
            .toLowerCase()
            .replace(/[^\p{L}\p{N}]+/gu, "");

// Набор типов, где ожидаем "Verified Purchase"
    const expectsVerified = (assTypeId) => {
        const MUST_BE_VERIFIED = new Set([3,4,5,6,11,12,13,15,16,17,24,25,26,27]);
        return MUST_BE_VERIFIED.has(Number(assTypeId));
    };

// ==== вычисляем расхождения (положи выше return) ====
    const mismatches = [];
    let asinNote = null;

    if (reviewData && assignmentData) {
        const expASIN   = getExpectedAsinByType(assignmentData?.booksTypeId, assignmentData?.book);
        const gotASIN   = (reviewData?.asin || "").trim();
        const fromThisBook = isAsinOfThisBook(gotASIN, assignmentData?.book);

        // ASIN
        if (gotASIN) {
            if (!fromThisBook) {
                mismatches.push({
                    field: "ASIN",
                    expected: expASIN || "(ASIN for selected book type)",
                    got: gotASIN,
                    note: "ASIN does not belong to this book.",
                });
            } else if (expASIN && gotASIN !== expASIN) {
                asinNote = `ASIN is from this book but a different format: expected ${BOOK_TYPE_LABEL[assignmentData?.booksTypeId]} (${expASIN}), got ${gotASIN}.`;
            }
        }

        // Reviewer Name
        const expName = normalize(expectedReviewerName);
        const gotName = normalize(reviewData?.review_name);
        if (expName && gotName && expName !== gotName) {
            mismatches.push({
                field: "Reviewer name",
                expected: expectedReviewerName,
                got: reviewData?.review_name,
                note: "Names differ.",
            });
        }

        // Verified / Unverified
        const needVerified = expectsVerified(assignmentData?.assTypeId);
        const gotVerified  = /verified/i.test(reviewData?.review_status || "");
        if (needVerified !== gotVerified) {
            mismatches.push({
                field: "Verification",
                expected: needVerified ? "Verified Purchase" : "Unverified allowed",
                got: reviewData?.review_status || "—",
                note: "Verification status does not match assignment requirements.",
            });
        }

        // Rating
        const expRating = Number(assignmentData?.rating);
        const gotRating = Number(reviewData?.review_rating);
        if (!Number.isNaN(expRating) && !Number.isNaN(gotRating) && expRating > 0 && gotRating > 0 && expRating !== gotRating) {
            mismatches.push({
                field: "Rating",
                expected: `${expRating}★`,
                got: `${gotRating}★`,
                note: "Rating differs.",
            });
        }
    }

    // ↑ выше return, рядом с helpers/mismatches/asinNote
    const [autoStaffComment, setAutoStaffComment] = useState("");

// Генератор текста для staff comment
    const buildAutoStaffComment = (a, r, mismatches, asinNote) => {
        const lines = [];
        lines.push("We checked your review link and found some differences versus the assignment:");

        mismatches.forEach((m, i) => {
            lines.push(`${i + 1}) ${m.field}: expected ${m.expected}, received ${m.got}. ${m.note || ""}`.trim());
        });

        if (asinNote) {
            lines.push(`ASIN note: ${asinNote}`);
        }

        lines.push("Please update the link or clarify in a reply. Thank you!");
        return lines.join("\n");
    };

// Когда появляется reviewData — считаем рассогласования и формируем текст
    useEffect(() => {
        if (!reviewData || !assignmentData) {
            setAutoStaffComment("");
            return;
        }
        // используем уже посчитанные выше mismatches и asinNote
        if ((mismatches?.length || 0) > 0 || asinNote) {
            setAutoStaffComment(buildAutoStaffComment(assignmentData, reviewData, mismatches, asinNote));
        } else {
            setAutoStaffComment("");
        }
    }, [reviewData, assignmentData?.id /*, mismatches, asinNote */]);

    const isVideoUrl = (u = "") =>
        /\.mp4(\?|$)/i.test(u) || u.includes("/vse-vms-transcoding-artifact-");

    const pickFirst = (...vals) => vals.find(Boolean) || "";

    const buildAssignmentProofUrl = (val) => {
        if (!val) return null;
        if (/^https?:\/\//i.test(val)) return val;
        return `${process.env.REACT_APP_API_URL}photo_proofs/${val}`;
    };

    const getAssignmentProofUrls = (data) => ([
        data?.checked_review_photo,
        data?.checked_review_photo2,
        data?.checked_review_photo3,
        data?.checked_review_photo4,
        data?.checked_review_photo5,
    ].map(buildAssignmentProofUrl).filter(Boolean));

    const isSingleProofAssignment = SINGLE_PROOF_REQUIRED_ASS_TYPES.includes(Number(assignmentData?.assTypeId));
    const showProofModerationActions =
        isProofRequiredAssignment(assignmentData?.assTypeId) &&
        assignmentData?.assignment_status !== "SUCCESS";
    const assignmentProofUrls = getAssignmentProofUrls(assignmentData);
    const proofFallback = `${process.env.REACT_APP_API_URL}covers/empty-cover.jpg`;

    /** Рисуем превью для ключей review_photo, review_photo2..5 */
    const renderMediaThumb = (key, value, data) => {
        // Для review_photo — если пусто, берём фото2/3/4/5
        let url = value || (key === "review_photo"
            ? pickFirst(data.review_photo2, data.review_photo3, data.review_photo4, data.review_photo5)
            : "");

        if (!url) return value?.toString() ?? "";

        // Видео: показываем <video> с постером (slate если будет, иначе первая доступная фотка)
        if (isVideoUrl(url)) {
            const poster = pickFirst(
                data.review_video_slate,      // если когда-нибудь добавишь в payload
                data.review_photo2,
                data.review_photo3,
                data.review_photo4,
                data.review_photo5
            ) || undefined;

            return (
                <video
                    src={url}
                    poster={poster}
                    preload="metadata"
                    className="img-thumbnail"
                    style={{ maxWidth: "80px", height: "auto", cursor: "pointer" }}
                    onClick={() => setFullImage(url)}
                />
            );
        }

        // Фото
        return (
            <img
                src={url}
                alt="Review"
                className="img-thumbnail"
                style={{ maxWidth: "80px", height: "auto", cursor: "pointer" }}
                onClick={() => setFullImage(url)}
            />
        );
    };


    return (
        <Modal show={show} size="xl" onHide={internalhandleClose} top>
            <Modal.Header closeButton style={{height: 64 }}>
                <div className="d-flex align-items-center justify-content-between gap-3 w-100">
                <Modal.Title className="fs-5">Ass ID: {assignmentData?.id}, Book ID: {assignmentData?.book?.id}, Owner ID: {assignmentData?.owner?.id}, Reader ID: {assignmentData?.reviewer?.id}   {loading && '   Refreshing assignment…'}</Modal.Title>
                <div className="d-flex gap-2 ms-auto me-4">
                    <Button
                        type="button"
                        variant="outline-success"
                        size="sm"
                        onClick={() => closeAndOpenSearch(onOpenUserAuthorAssignments, assignmentData?.userId || assignmentData?.owner?.id)}
                    >
                        Els Author Ass
                    </Button>
                    <Button
                        type="button"
                        variant="outline-success"
                        size="sm"
                        onClick={() => closeAndOpenSearch(onOpenUserReviewerAssignments, assignmentData?.reviewer_id || assignmentData?.reviewer?.id)}
                    >
                        Els Reviewer Ass
                    </Button>
                    <Button
                        type="button"
                        variant="outline-success"
                        size="sm"
                        onClick={() => closeAndOpenSearch(onOpenBookAssignments, assignmentData?.bookId || assignmentData?.book?.id)}
                    >
                        All Ass of this Book
                    </Button>
                </div>
                {/*{messageS && (*/}
                {/*    <div className="d-flex justify-content-center">*/}
                {/*        <Alert*/}
                {/*            variant="secondary"*/}
                {/*            className="mb-0 ms-3 fw-semibold small border-secondary fw-normal d-inline-block text-center text-nowrap px-2 py-1"*/}
                {/*        >*/}
                {/*            {messageS}*/}
                {/*        </Alert>*/}
                {/*    </div>*/}
                {/*)}*/}
                </div>
            </Modal.Header>
            <Modal.Body>
                <Row className="mb-3">
                    <Col md={2} className="d-flex align-items-center justify-content-center text-center">
                        <Image
                            src={
                                assignmentData.book?.cover_file
                                    ? `${process.env.REACT_APP_API_URL}covers/${assignmentData.book?.cover_file}`
                                    : `${process.env.REACT_APP_API_URL}covers/empty-cover.jpg`
                            }
                            style={{width: '90%', objectFit: 'cover', borderRadius: '6px'}}
                            className="shadow ms-2"
                            alt="Book Cover"
                        />


                    </Col>

                    <Col md={10} className="d-flex align-items-stretch h-100">
                        <Card className="w-100 mt-0">
                            <Card.Body>
                                <Card.Title className="mb-0">
                                    <p className="mx-auto fs-6 mb-0 text-muted">
                                        {assignmentData.book?.title || 'No title available'}
                                    </p>
                                    <p style={{marginBottom: '-10px', fontSize: 'small'}}
                                       className="mx-auto fst-italic fs-6 lh-sm fw-normal mb-1 p-0 text-muted">
                                        {assignmentData.book?.subtitle || 'No subtitle available'}
                                    </p>
                                    <p style={{marginBottom: '-10px', fontSize: 'small'}}
                                       className="mx-auto fst-italic small mb-2 ">
                                        by {assignmentData.book?.author || 'No author available'}
                                    </p>
                                    <Row>
                                        <Col md={5}>

                                            <p style={{marginBottom: '-10px', fontSize: 'small'}}
                                               className="mx-auto small mb-2 ">
                                                Virt: &nbsp;
                                                {[...Array(5)]?.map((_, index) => (
                                                    <i
                                                        key={index}
                                                        className={`bi bi-star${index < assignmentData?.rating ? '-fill' : ''}`}
                                                        style={{
                                                            color: index < assignmentData?.rating ? 'gold' : 'lightgray',
                                                            fontSize: '12px',
                                                            marginRight: '4px'
                                                        }}
                                                    ></i>
                                                ))} &nbsp;&nbsp;&nbsp;Amz: &nbsp;
                                                {[...Array(5)]?.map((_, index) => (
                                                    <i
                                                        key={index}
                                                        className={`bi bi-star${index < assignmentData?.checked_review_rating ? '-fill' : ''}`}
                                                        style={{
                                                            color: index < assignmentData?.checked_review_rating ? 'gold' : 'lightgray',
                                                            fontSize: '12px',
                                                            marginRight: '4px'
                                                        }}
                                                    ></i>
                                                ))}
                                            </p>
                                            <p className="mx-auto text-muted small mb-2 ">
                                                <FaStackExchange className="me-2" />
                                               {assignmentData?.assignment_status} / {assignmentData?.reviewer_reading_step}
                                            </p>
                                            <ListGroup variant="success">

                                                <ListGroup.Item style={{ paddingTop: "0.10rem", paddingBottom: "0.10rem", fontSize: 'small'}}>
                                                    <p className="me-2 mb-0 mt-0 text-muted">
                                                        Prefer C/Q:  <span className="fw-bolder">{assignmentData?.assignment_prefer_country || "All"} / {assignmentData?.rating_of_reviewer ? assignmentData?.rating_of_reviewer : "Any "}%</span>
                                                    </p>
                                                </ListGroup.Item>
                                                <ListGroup.Item style={{ paddingTop: "0.10rem", paddingBottom: "0.10rem", fontSize: 'small'}}>
                                                    <p className="me-2 mb-0 mt-0 text-muted">
                                                        Expect:  <span className="fw-bolder">{expect}</span>
                                                    </p>
                                                </ListGroup.Item>
                                                <ListGroup.Item style={{ paddingTop: "0.10rem", paddingBottom: "0.10rem", fontSize: 'small'}}>
                                                    <p className="me-2 mb-0 mt-0 text-muted">
                                                        <FaBookOpen className="me-2" />
                                                        Type:
                                                        <span className="fw-bolder">
    {/* Book formats */}
                                                            {assignmentData?.booksTypeId === 1 && <> Kindle {assignmentData?.book?.kindle_asin}</>}
                                                            {assignmentData?.booksTypeId === 2 && <> Paperback {assignmentData?.book?.paper_back_asin}</>}
                                                            {assignmentData?.booksTypeId === 3 && <> Hardcover {assignmentData?.book?.hard_cover_asin}</>}
                                                            {assignmentData?.booksTypeId === 4 && <> Audio {assignmentData?.book?.audio_asin || assignmentData?.book?.audio_audible_asin}</>}

                                                            {/* Any book format (your existing logic) */}
                                                            {(assignmentData?.booksTypeId === 5 || assignmentData?.booksTypeId === 6) && (
                                                                <>
                                                                    Any{" "}
                                                                    {assignmentData?.book?.kindle_asin ||
                                                                        assignmentData?.book?.paper_back_asin ||
                                                                        assignmentData?.book?.hard_cover_asin ||
                                                                        assignmentData?.book?.audio_asin ||
                                                                        assignmentData?.book?.audio_audible_asin}
                                                                </>
                                                            )}

                                                            {/* ✅ 7 — Product */}
                                                            {assignmentData?.booksTypeId === 7 && (
                                                                <> Product {assignmentData?.book?.kindle_asin} </>
                                                            )}

                                                            {/* ✅ 8 —  */}
                                                            {assignmentData?.booksTypeId === 8 && (
                                                                <> Product {assignmentData?.book?.paper_back_asin} </>
                                                            )}

                                                            {/* ✅ 9 — Product  */}
                                                            {assignmentData?.booksTypeId === 9 && (
                                                                <> Product Variant {assignmentData?.book?.hard_cover_asin} </>
                                                            )}

                                                            {/* ✅ 10 — Product  */}
                                                            {assignmentData?.booksTypeId === 10 && (
                                                                <> Product {assignmentData?.book?.audio_asin} </>
                                                            )}
</span>


                                                    </p>
                                                </ListGroup.Item>
                                                <ListGroup.Item style={{ paddingTop: "0.10rem", paddingBottom: "0.10rem", fontSize: 'small'}}>
                                                    <p className="me-2 mb-0 mt-0 text-muted">
                                                        <FaTasks className="me-2" />
                                                        Ass Type:
                                                        <span className="fw-bolder">
                                                           {assignmentData?.assTypeId === 1 && " Universal Assignment"}
                                                            {assignmentData?.assTypeId === 2 && " Kindle Unlimited"}
                                                            {assignmentData?.assTypeId === 3 && " Verified Purchase"}
                                                            {assignmentData?.assTypeId === 4 && " Verified Purchase Img"}
                                                            {assignmentData?.assTypeId === 5 && " Ver/Pur Search&Buy"}
                                                            {assignmentData?.assTypeId === 6 && " Ver/Pur Search&Buy Img"}
                                                            {assignmentData?.assTypeId === 7 && " Universal Audio"}
                                                            {assignmentData?.assTypeId === 8 && " Audible Promo Code"}
                                                            {assignmentData?.assTypeId === 9 && " Verified Kindle Unlimited"}

                                                            {assignmentData?.assTypeId === 10 && " Paperback BuyOut"}
                                                            {assignmentData?.assTypeId === 11 && " PB Search&BuyOut"}
                                                            {assignmentData?.assTypeId === 12 && " PB Verified + Img"}
                                                            {assignmentData?.assTypeId === 13 && " PB Verified + Video"}

                                                            {assignmentData?.assTypeId === 14 && " Hardcover BuyOut"}
                                                            {assignmentData?.assTypeId === 15 && " HC Search&BuyOut"}
                                                            {assignmentData?.assTypeId === 16 && " HC Verified + Img"}
                                                            {assignmentData?.assTypeId === 17 && " HC Verified + Video"}

                                                            {assignmentData?.assTypeId === 18 && " PB Verified Purchase"}
                                                            {assignmentData?.assTypeId === 19 && " PB Verified Search&Buy"}
                                                            {assignmentData?.assTypeId === 20 && " HC Verified Purchase"}
                                                            {assignmentData?.assTypeId === 21 && " HC Verified Search&Buy"}

                                                            {assignmentData?.assTypeId === 22 && " Product BuyOut"}
                                                            {assignmentData?.assTypeId === 23 && " Product Search&BuyOut"}
                                                            {assignmentData?.assTypeId === 24 && " Product Verified"}
                                                            {assignmentData?.assTypeId === 25 && " Product Verified + Img"}
                                                            {assignmentData?.assTypeId === 26 && " Product Verified + Video"}
                                                            {assignmentData?.assTypeId === 27 && " Product Verified Search&Buy"}

                                                            {assignmentData?.assTypeId === 28 && " Make Helpful Internal"}
                                                            {assignmentData?.assTypeId === 29 && " Write Report Internal"}
                                                            {assignmentData?.assTypeId === 30 && " Make Helpful External"}
                                                            {assignmentData?.assTypeId === 31 && " Write Report External"}
                                                            {assignmentData?.assTypeId === 32 && " Set Stars Rating"}

                                                        </span>
                                                    </p>
                                                </ListGroup.Item>
                                                <ListGroup.Item style={{ paddingTop: "0.10rem", paddingBottom: "0.10rem", fontSize: 'small'}}>
                                                    <p className="me-2 mb-0 mt-0 text-muted">
                                                        Search Term / Cost: <span className="fw-bolder"> {assignmentData?.assignment_search_term || "N/A"} /{" "}</span>
                                                        Spends:
                                                        <span className="fw-bolder">
                                                            {(assignmentData?.assTypeId >= 10 && assignmentData?.assTypeId <= 17)
                                                                ? ` $${(+assignmentData?.book_cost_compensation || 0).toFixed(2)}`
                                                                : (
                                                                    assignmentData?.booksPriceId === 1 ? " FREE" :
                                                                        assignmentData?.booksPriceId === 2 ? " $0.99" :
                                                                            assignmentData?.booksPriceId === 3 ? " $1.99" :
                                                                                assignmentData?.booksPriceId === 4 ? " $2.99" :
                                                                                    assignmentData?.booksPriceId === 5 ? " $3.99" :
                                                                                        assignmentData?.booksPriceId === 6 ? " $4.99" :
                                                                                            assignmentData?.booksPriceId === 7 ? " $5.99" :
                                                                                                assignmentData?.booksPriceId === 8 ? " $6.99" :
                                                                                                    assignmentData?.booksPriceId === 9 ? " 7.99" :
                                                                                                        assignmentData?.booksPriceId === 10 ? " $8.99" :
                                                                                                            assignmentData?.booksPriceId === 11 ? " $9.99" : ""

                                                                )
                                                            }
                                                        </span>
                                                    </p>
                                                </ListGroup.Item>
                                                <ListGroup.Item style={{ paddingTop: "0.10rem", paddingBottom: "0.10rem", fontSize: 'small'}}>
                                                    <p className="me-2 ms-0 mb-0 mt-0 text-muted">
                                                        R Earn / P Spend: <span className="fw-semibold">{assignmentData?.assignment_price_reader} Virt
                                                        {assignmentData?.received_bonus > 0 && (" + " + assignmentData?.received_bonus + " Virt")} / {assignmentData?.assignment_price_publisher} Virt</span>
                                                    </p>
                                                </ListGroup.Item>
                                                <ListGroup.Item style={{ paddingTop: "0.10rem", paddingBottom: "0.10rem", fontSize: 'small'}}>
                                                    <p className="me-2 mb-0 mt-0 text-muted">
                                                        <span className="fw-semibold">Expected reviewer: {expectedReviewerName || "N/A"}</span>
                                                    </p>
                                                </ListGroup.Item>
                                            </ListGroup>
                                        </Col>
                                        <Col md={7}>
                                            <Card className="mt-0 p-0 small border border-secondary shadow-sm rounded">
                                                <Card.Header className="py-1 small">
                                    <span className="mt-0 mb-0 small fw-semibold">Find R: {(() => {
                                        const a = (expectedReviewerName || "No Reviewer for now").trim();
                                        const b = (reviewData?.review_name || assignmentData?.checked_review_name || "No Reviewer for now").trim();
                                        const equal =
                                            a && b ? a.localeCompare(b, undefined, { sensitivity: "accent" }) === 0 : a === b;

                                        return (
                                            <span className={equal ? "text-success fs-6 fw-semibold" : "fs-6 text-danger"}>
      {equal ? a : `${a} / ${b}`}
    </span>
                                        );
                                    })()} on  <span>
                                    {assignmentData?.booksTypeId === 1 && <> Kindle {assignmentData?.book?.kindle_asin}</>}
                                        {assignmentData?.booksTypeId === 2 && <> Paperback {assignmentData?.book?.paper_back_asin}</>}
                                        {assignmentData?.booksTypeId === 3 && <> Hardcover {assignmentData?.book?.hard_cover_asin}</>}
                                        {assignmentData?.booksTypeId === 4 && <> Audio {assignmentData?.book?.audio_asin || assignmentData?.book?.audio_audible_asin}</>}
                                        {(assignmentData?.booksTypeId === 5 || assignmentData?.booksTypeId === 6) && <> Any {assignmentData?.book?.kindle_asin || assignmentData?.book?.paper_back_asin || assignmentData?.book?.hard_cover_asin|| assignmentData?.book?.audio_asin || assignmentData?.book?.audio_audible_asin}</>}
                                        {/* ✅ 7 — Product */}
                                        {assignmentData?.booksTypeId === 7 && (
                                            <> Product {assignmentData?.book?.kindle_asin} </>
                                        )}

                                        {/* ✅ 8 —  */}
                                        {assignmentData?.booksTypeId === 8 && (
                                            <> Product {assignmentData?.book?.paper_back_asin} </>
                                        )}

                                        {/* ✅ 9 — Product  */}
                                        {assignmentData?.booksTypeId === 9 && (
                                            <> Product Variant {assignmentData?.book?.hard_cover_asin} </>
                                        )}

                                        {/* ✅ 10 — Product  */}
                                        {assignmentData?.booksTypeId === 10 && (
                                            <> Product {assignmentData?.book?.audio_asin} </>
                                        )}
                                </span>
                                </span>
                                                </Card.Header>
                                                <Card.Body className="d-flex flex-wrap gap-2 justify-content-center align-items-center" style={{ minHeight: 62 }}>

                                                    <Button
                                                        variant="success"
                                                        className="btn-sm"
                                                        disabled={!assignmentData?.book?.kindle_asin}
                                                        onClick={async () => {
                                                            try {
                                                                const targetUrl = `${reviewerData?.amz_country}/product-reviews/${assignmentData?.book?.kindle_asin}/ref=cm_cr_arp_d_viewopt_srt?ie=UTF8&reviewerType=all_reviews&sortBy=recent&pageNumber=1`;
                                                                const response = await getRedirectUrlApi(targetUrl);
                                                                if (response?.redirectUrl) window.open(response.redirectUrl, "_blank", "noreferrer");
                                                            } catch (err) { console.error("Redirect error:", err); }
                                                        }}
                                                    >
                                                        Kindle
                                                    </Button>

                                                    <Button
                                                        variant="success"
                                                        className="btn-sm"
                                                        disabled={!assignmentData?.book?.paper_back_asin}
                                                        onClick={async () => {
                                                            try {
                                                                const targetUrl = `${reviewerData?.amz_country}/product-reviews/${assignmentData?.book?.paper_back_asin}/ref=cm_cr_arp_d_viewopt_srt?ie=UTF8&reviewerType=all_reviews&sortBy=recent&pageNumber=1`;
                                                                const response = await getRedirectUrlApi(targetUrl);
                                                                if (response?.redirectUrl) window.open(response.redirectUrl, "_blank", "noreferrer");
                                                            } catch (err) { console.error("Redirect error:", err); }
                                                        }}
                                                    >
                                                        PB
                                                    </Button>

                                                    <Button
                                                        variant="success"
                                                        className="btn-sm"
                                                        disabled={!assignmentData?.book?.hard_cover_asin}
                                                        onClick={async () => {
                                                            try {
                                                                const targetUrl = `${reviewerData?.amz_country}/product-reviews/${assignmentData?.book?.hard_cover_asin}/ref=cm_cr_arp_d_viewopt_srt?ie=UTF8&reviewerType=all_reviews&sortBy=recent&pageNumber=1`;
                                                                const response = await getRedirectUrlApi(targetUrl);
                                                                if (response?.redirectUrl) window.open(response.redirectUrl, "_blank", "noreferrer");
                                                            } catch (err) { console.error("Redirect error:", err); }
                                                        }}
                                                    >
                                                        HC
                                                    </Button>

                                                    <Button
                                                        variant="success"
                                                        className="btn-sm"
                                                        disabled={!assignmentData?.book?.audio_asin}
                                                        onClick={async () => {
                                                            try {
                                                                const targetUrl = `${reviewerData?.amz_country}/dp/${assignmentData?.book?.audio_asin}/ref=cm_cr_arp_d_viewopt_srt?ie=UTF8&reviewerType=all_reviews&sortBy=recent&pageNumber=1`;
                                                                const response = await getRedirectUrlApi(targetUrl);
                                                                if (response?.redirectUrl) window.open(response.redirectUrl, "_blank", "noreferrer");
                                                            } catch (err) { console.error("Redirect error:", err); }
                                                        }}
                                                    >
                                                        Audio
                                                    </Button>

                                                    <Button
                                                        variant="success"
                                                        className="btn-sm"
                                                        disabled={!assignmentData?.book?.audio_audible_asin}
                                                        onClick={async () => {
                                                            try {
                                                                const targetUrl = `${reviewerData?.audible_country}/product-reviews/${assignmentData?.book?.audio_audible_asin}`;
                                                                const response = await getRedirectUrlApi(targetUrl);
                                                                if (response?.redirectUrl) window.open(response.redirectUrl, "_blank", "noreferrer");
                                                            } catch (err) { console.error("Redirect error:", err); }
                                                        }}
                                                    >
                                                        Audible
                                                    </Button>
                                                    <Button
                                                        variant="success"
                                                        className="btn-sm"
                                                        disabled={!assignmentData?.review_link}
                                                        onClick={async () => {
                                                            try {
                                                                const targetUrl = `${assignmentData?.review_link}`;
                                                                const response = await getRedirectUrlApi(targetUrl);
                                                                if (response?.redirectUrl) window.open(response.redirectUrl, "_blank", "noreferrer");
                                                            } catch (err) { console.error("Redirect error:", err); }
                                                        }}
                                                    >
                                                        Review Link
                                                    </Button>


                                                </Card.Body>
                                            </Card>
                                            <Card className="mt-0 p-0 small mt-2 border border-secondary shadow-sm rounded">

                                                <Card.Header className="py-1 small"> <span className="mt-0 mb-0 small fw-semibold">Linked Logs for this Assignment and Anti-Fraud:</span></Card.Header>
                                                <Card.Body className="d-flex flex-wrap gap-2 justify-content-center align-items-center" style={{ minHeight: 62 }}>
                                                    <Button
                                                        variant="secondary"
                                                        size="sm"
                                                        onClick={getLogs}
                                                        disabled={loadingId !== null}
                                                    >
                                                        {loadingId === "allLogs" ? (
                                                            <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                                                        ) : "All"}
                                                    </Button>

                                                    <Button
                                                        variant="secondary"
                                                        size="sm"
                                                        onClick={getALogs}
                                                        disabled={loadingId !== null}
                                                    >
                                                        {loadingId === "authorLogs" ? (
                                                            <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                                                        ) : "Author"}
                                                    </Button>

                                                    <Button
                                                        variant="danger"
                                                        size="sm"
                                                        onClick={() => getLinked(assignmentData?.userId)}
                                                        disabled={loadingId !== null}
                                                        title="Find intersections by device/browser/IP/fingerprint Author"
                                                    >
                                                        {loadingId === `fraud:${assignmentData?.userId}` ? (
                                                            <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                                                        ) : "A-Fraud"}
                                                    </Button>

                                                    <Button
                                                        variant="secondary"
                                                        size="sm"
                                                        onClick={getRLogs}
                                                        disabled={loadingId !== null}
                                                    >
                                                        {loadingId === "reviewerLogs" ? (
                                                            <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                                                        ) : "Reviewer"}
                                                    </Button>

                                                    <Button
                                                        variant="danger"
                                                        size="sm"
                                                        onClick={() => getLinked(assignmentData?.reviewer_id)}
                                                        disabled={loadingId !== null}
                                                        title="Find intersections by device/browser/IP/fingerprint Reviever"
                                                    >
                                                        {loadingId === `fraud:${assignmentData?.reviewer_id}` ? (
                                                            <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                                                        ) : "R-Fraud"}
                                                    </Button>



                                                    <Button variant="secondary" size="sm" onClick={clearLogs}>Clear</Button>


                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    </Row>



                                </Card.Title>
                            </Card.Body>

                        </Card>
                    </Col>

                </Row>
                <Row className="mb-2">
                    <Col md={12}>
                        {renderUserPanel({
                            title: "Author",
                            data: ownerData || assignmentData?.owner,
                            roleId: assignmentData?.userId || assignmentData?.owner?.id,
                            showEditor: showAuthorEditor,
                            setShowEditor: setShowAuthorEditor,
                            editor: authorEditor,
                            setEditor: setAuthorEditor,
                        })}
                        {renderUserPanel({
                            title: "Reviewer",
                            data: reviewerData || assignmentData?.reviewer,
                            roleId: assignmentData?.reviewer_id || assignmentData?.reviewer?.id,
                            showEditor: showReviewerEditor,
                            setShowEditor: setShowReviewerEditor,
                            editor: reviewerEditor,
                            setEditor: setReviewerEditor,
                        })}
                    </Col>
                </Row>
                <AdminAmazonReviewParserExt
                assignmentData={assignmentData}
                onSaved={(msg /*, resp*/) => {
                setMessageS(msg);          // показываем текст от сервера
                refetchAssignment();       // и перечитываем ассигмент
                }}
                defaultLink={assignmentData?.checked_review_link || assignmentData?.review_link || ""}
                />
                {isSingleProofAssignment && (
                    <Card className="mt-2 p-0 border border-secondary shadow-sm rounded">
                        <Card.Header className="py-1 small d-flex align-items-center justify-content-between gap-2">
                            <span>
                                {Number(assignmentData?.assTypeId) === 32
                                    ? "Star Rating Proof"
                                    : [28, 30].includes(Number(assignmentData?.assTypeId))
                                        ? "Helpful Vote Proof"
                                        : "Report Proof"}
                            </span>
                            {showProofModerationActions && (
                                <span className="d-flex align-items-center gap-2">
                                    <Button
                                        variant="success"
                                        size="sm"
                                        disabled={loading || assignmentProofUrls.length === 0}
                                        onClick={handleProofApprove}
                                    >
                                        Approve
                                    </Button>
                                    <Button
                                        variant="outline-danger"
                                        size="sm"
                                        disabled={loading || assignmentProofUrls.length === 0}
                                        onClick={handleProofReject}
                                    >
                                        Reject
                                    </Button>
                                </span>
                            )}
                        </Card.Header>
                        <Card.Body className="p-2">
                            {assignmentProofUrls.length > 0 ? (
                                <div className="d-flex flex-wrap gap-2">
                                    {assignmentProofUrls.map((url, idx) => (
                                        <div key={`assignment-proof-${idx}`} style={{ width: 220 }}>
                                            <ProofImageCard
                                                src={url}
                                                alt={`Assignment proof ${idx + 1}`}
                                                fallbackSrc={proofFallback}
                                            />
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div className="text-muted small">
                                    No proof screenshot is attached to this assignment yet.
                                </div>
                            )}
                        </Card.Body>
                    </Card>
                )}
                {initialAssignmentFromTable?.assTypeId === 8 && (
                        <>
                            <Row className="mt-3">
                                <Col md={6}>

                                    <div>
                                        <h6>Provide the direct link to your Reviewer Page on Audible:</h6>
                                        <AudibleReviewParser onExtract={handleExtractAudibleReview} setCurrentStep={setCurrentStep}/>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    {currentStep !== "STEP1" && (
                                        <div>
                                            <h6 className="text-muted mt-0">Instruction:</h6>
                                            <ListGroup variant="success" className="text-muted fst-italic">
                                                <ListGroup.Item
                                                    className="text-muted"
                                                    style={{
                                                        paddingTop: '0.20rem', // Уменьшение высоты строки
                                                        paddingBottom: '0.20rem', // Уменьшение высоты строки
                                                        marginRight: '10px',
                                                    }}
                                                >
                                                    Step 1: Find your Reviewer Page on Audible. This is the page where your name is displayed along with all your published reviews, from the most recent to the oldest.
                                                </ListGroup.Item>
                                                <ListGroup.Item
                                                    className="text-muted"
                                                    style={{
                                                        paddingTop: '0.20rem', // Уменьшение высоты строки
                                                        paddingBottom: '0.20rem', // Уменьшение высоты строки
                                                        marginRight: '10px',
                                                    }}
                                                >
                                                    Step 2: Make sure that your review for this book is published and appears as the most recent one, meaning it should be the first in the list.
                                                </ListGroup.Item>
                                                <ListGroup.Item
                                                    className="text-muted"
                                                    style={{
                                                        paddingTop: '0.20rem', // Уменьшение высоты строки
                                                        paddingBottom: '0.20rem', // Уменьшение высоты строки
                                                        marginRight: '10px',
                                                    }}
                                                >
                                                    Step 3: Copy URL of Reviewer Page and Paste it into the
                                                    input field.</ListGroup.Item>
                                                <ListGroup.Item
                                                    className="text-muted"
                                                    style={{
                                                        paddingTop: '0.20rem', // Уменьшение высоты строки
                                                        paddingBottom: '0.20rem', // Уменьшение высоты строки
                                                        marginRight: '10px',
                                                    }}
                                                >
                                                    Step 4: Click 'Submit Review Link' to speed up
                                                    approval!</ListGroup.Item>
                                            </ListGroup>
                                        </div>
                                    )}
                                </Col>
                            </Row>
                        </>
                    )}

                <Card className="mt-1 p-1 border border-secondary shadow-sm rounded">
                   <Card.Body className="">
                <Row className="mt-0">
                    {assignmentData ? (
                        <>
                            <Col md={8}>
                                <AmazonReviewLinkStaffEditor
                                    assignmentData={assignmentData}
                                    onSaved={refetchAssignment}
                                    presetStaffComment={autoStaffComment}
                                />

                            </Col>
                            <Col md={4}>
                                <Card className="mt-0 p-0 border border-secondary shadow-sm rounded">
                                    <Card.Header className="py-1 small">Amazon.com:</Card.Header>
                                    <Card.Body className="d-flex flex-wrap gap-2 justify-content-center align-items-center" style={{ minHeight: 62 }}>
                                        <Button
                                            variant="info"
                                            className="btn-sm"
                                            disabled={!assignmentData?.book?.kindle_asin}
                                            onClick={async () => {
                                                try {
                                                    const targetUrl = `https://amazon.com/dp/${assignmentData?.book?.kindle_asin}`;
                                                    const response = await getRedirectUrlApi(targetUrl);
                                                    if (response?.redirectUrl) window.open(response.redirectUrl, "_blank", "noreferrer");
                                                } catch (err) { console.error("Redirect error:", err); }
                                            }}
                                        >
                                            K
                                        </Button>

                                        <Button
                                            variant="info"
                                            className="btn-sm"
                                            disabled={!assignmentData?.book?.paper_back_asin}
                                            onClick={async () => {
                                                try {
                                                    const targetUrl = `https://amazon.com/dp/${assignmentData?.book?.paper_back_asin}`;
                                                    const response = await getRedirectUrlApi(targetUrl);
                                                    if (response?.redirectUrl) window.open(response.redirectUrl, "_blank", "noreferrer");
                                                } catch (err) { console.error("Redirect error:", err); }
                                            }}
                                        >
                                            PB
                                        </Button>

                                        <Button
                                            variant="info"
                                            className="btn-sm"
                                            disabled={!assignmentData?.book?.hard_cover_asin}
                                            onClick={async () => {
                                                try {
                                                    const targetUrl = `https://amazon.com/dp/${assignmentData?.book?.hard_cover_asin}`;
                                                    const response = await getRedirectUrlApi(targetUrl);
                                                    if (response?.redirectUrl) window.open(response.redirectUrl, "_blank", "noreferrer");
                                                } catch (err) { console.error("Redirect error:", err); }
                                            }}
                                        >
                                            HC
                                        </Button>

                                        <Button
                                            variant="info"
                                            className="btn-sm"
                                            disabled={!assignmentData?.book?.audio_asin}
                                            onClick={async () => {
                                                try {
                                                    const targetUrl = `https://amazon.com/dp/${assignmentData?.book?.audio_asin}`;
                                                    const response = await getRedirectUrlApi(targetUrl);
                                                    if (response?.redirectUrl) window.open(response.redirectUrl, "_blank", "noreferrer");
                                                } catch (err) { console.error("Redirect error:", err); }
                                            }}
                                        >
                                            A
                                        </Button>

                                        <Button
                                            variant="info"
                                            className="btn-sm"
                                            disabled={!assignmentData?.book?.audio_audible_asin}
                                            onClick={async () => {
                                                try {
                                                    const targetUrl = `https://audible.com/dp/${assignmentData?.book?.audio_audible_asin}`;
                                                    const response = await getRedirectUrlApi(targetUrl);
                                                    if (response?.redirectUrl) window.open(response.redirectUrl, "_blank", "noreferrer");
                                                } catch (err) { console.error("Redirect error:", err); }
                                            }}
                                        >
                                            AB
                                        </Button>
                                    </Card.Body>
                                </Card>
                                <Card className="mt-2 p-0 border border-secondary shadow-sm rounded">
                                    <Card.Header className="py-1 small">Manual Editing (Set New Parameters):</Card.Header>
                                    <Card.Body>
                                        <Form>
                                            <Form.Group className="d-flex justify-content-center align-items-center gap-3 mb-0 flex-wrap">
                                                <Dropdown onSelect={(value) => setSelectedStatus(value)}>
                                                    <Dropdown.Toggle variant="secondary" size="sm" style={{width: 130}}>
                                                        {selectedStatus || statusin}
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu>
                                                        {statusOptions.map((status) => (
                                                            <Dropdown.Item key={status} eventKey={status}>
                                                                {status}
                                                            </Dropdown.Item>
                                                        ))}
                                                    </Dropdown.Menu>
                                                </Dropdown>

                                                <Dropdown onSelect={(value) => setCurrentStep(value)}>
                                                    <Dropdown.Toggle variant="secondary" size="sm" style={{width: 80}}>
                                                        {currentStep || stepin}
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu>
                                                        {readingStep.map((step) => (
                                                            <Dropdown.Item key={step} eventKey={step}>
                                                                {step}
                                                            </Dropdown.Item>
                                                        ))}
                                                    </Dropdown.Menu>
                                                </Dropdown>

                                                <Button variant="success" size="sm" onClick={handleSaveChanges}>
                                                    Apply
                                                </Button>
                                            </Form.Group>
                                        </Form>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </>
                    ) : (
                        <div className="small text-muted">Loading assignment…</div>
                    )}


                </Row>

            </Card.Body>
        </Card>




                {reviewData && (mismatches.length > 0 || asinNote) && (
                    <Card className="mt-2 p-1 border border-secondary shadow-sm rounded small">
                        <Card.Body>
                            {asinNote && (
                                <Alert variant="warning" className="py-1 px-2 small mb-2">
                                    {asinNote}
                                </Alert>
                            )}

                            {mismatches.length > 0 && (
                                <div className="table-responsive">
                                    <table className="table table-sm table-bordered align-middle mb-0">
                                        <thead className="table-light">
                                        <tr>
                                            <th className="px-2 py-1">Field</th>
                                            <th className="px-2 py-1">Expected</th>
                                            <th className="px-2 py-1">Received</th>
                                            <th className="px-2 py-1">Detected mismatches</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {mismatches.map((m, i) => (
                                            <tr key={i} className="fst-italic">
                                                <td className="px-2 py-1">{m.field}</td>
                                                <td className="px-2 py-1">{m.expected ?? "—"}</td>
                                                <td className="px-2 py-1">{m.got ?? "—"}</td>
                                                <td className="px-2 py-1">{m.note ?? "—"}</td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </Card.Body>
                    </Card>
                )}


                {(assignmentData?.checked_review_name ||
                    assignmentData?.checked_review_photo ||
                    assignmentData?.checked_review_photo2 ||
                    assignmentData?.checked_review_photo3 ||
                    assignmentData?.checked_review_photo4 ||
                    assignmentData?.checked_review_photo5 ||
                    reviewData) && (() => {
                    const assTypeId = assignmentData?.assTypeId;
                    const compactMode = [10, 11, 14, 15, 18, 19, 20, 21, 22, 23, 24, 27, 28, 29, 30, 31, 32].includes(assTypeId);

                    const typeLabel = (() => {
                        switch (assignmentData?.assTypeId) {
                            case 1:  return "Universal Assignment";
                            case 2:  return "Kindle Unlimited";
                            case 3:  return "Verified Purchase";
                            case 4:  return "Verified Purchase Img";
                            case 5:  return "Ver/Pur Search&Buy";
                            case 6:  return "Ver/Pur Search&Buy Img";
                            case 7:  return "Universal Audio";
                            case 8:  return "Audible Promo Code";
                            case 9:  return "Verified Kindle Unlimited";
                            case 10: return "PB BuyOut";
                            case 11: return "PB Search&BuyOut";
                            case 12: return "PB Verified Purchase + Img";
                            case 13: return "PB Verified Purchase + Video";
                            case 14: return "HC BuyOut";
                            case 15: return "HC Search&BuyOut";
                            case 16: return "HC Verified Purchase + Img";
                            case 17: return "HC Verified Purchase + Video";
                            case 18: return "PB Verified Purchase";
                            case 19: return "PB VP Search&Buy";
                            case 20: return "HC Verified Purchase";
                            case 21: return "HC VP Search&Buy";
                            case 22: return "Product BuyOut";
                            case 23: return "Prod. Search&BuyOut";
                            case 24: return "Prod. Verified Pur.";
                            case 25: return "Prod. Verified + Img";
                            case 26: return "Prod. Verified + Vid";
                            case 27: return "Prod. VP Search&Buy";
                            case 28: return "Make Helpful Internal";
                            case 29: return "Write Report Internal";
                            case 30: return "Make Helpful External";
                            case 31: return "Write Report External";
                            case 32: return "Set Stars Rating";
                            default:
                                return assignmentData?.checked_review_status || reviewData?.review_status || "Unverified Purchase";
                        }
                    })();


                    // Хелпер для фото: если пришло только имя файла — собираем URL как {API}/photo_proofs/{file}
                    const buildPhotoUrl = (val) => {
                        if (!val) return null;
                        if (/^https?:\/\//i.test(val)) return val;
                        return `${process.env.REACT_APP_API_URL}photo_proofs/${val}`;
                    };

                    const proofUrls = [
                        assignmentData?.checked_review_photo,
                        assignmentData?.checked_review_photo2,
                        assignmentData?.checked_review_photo3,
                        assignmentData?.checked_review_photo4,
                        assignmentData?.checked_review_photo5,
                    ].map(buildPhotoUrl).filter(Boolean);
                    const hasProofs = proofUrls.length > 0;
                    const proofFallback = `${process.env.REACT_APP_API_URL}covers/empty-cover.jpg`;
                    const proofLabel = Number(assTypeId) === 32
                        ? "Star Rating Proof:"
                        : [28, 30].includes(Number(assTypeId))
                            ? "Helpful Vote Proof:"
                            : [29, 31].includes(Number(assTypeId))
                                ? "Report Proof:"
                                : "Purchase Photos:";

                    return (
                        <>
                            <h5 className="mb-3 mt-3">Full info about this Assignment:</h5>
                            <Row className="d-flex justify-content-center mt-2">
                                <Col md={11} className="shadow border border-secondary p-3 rounded bg-light text-start">

                                    {/* ====== COMPACT MODE FOR BuyOut TYPES (10/11/14/15) ====== */}
                                    {compactMode ? (
                                        <>
                                            {/* Desktop/Tablet (>= md): компактная таблица */}
                                            <div className="d-none d-md-block">
                                                <div className="table-responsive">
                                                    <table className="table table-sm table-bordered align-middle small mb-2">
                                                        <thead className="bg-secondary bg-opacity-50 text-sm">
                                                        <tr>
                                                            <th className="px-2 py-1">Reviewer</th>
                                                            <th className="px-2 py-1">ExpR</th>
                                                            <th className="px-2 py-1">ASIN</th>
                                                            <th className="px-2 py-1">Type</th>
                                                            <th className="px-2 py-1">Confirm?</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        <tr>
                                                            <td className="px-2 py-1 fw-semibold">
                                                                {assignmentData?.reviewer_name || "No Name"}
                                                            </td>
                                                            <td className="px-2 py-1 fw-semibold">
                                                                {assignmentData?.rating || reviewData?.review_rating || "N/A"}
                                                            </td>
                                                            <td className="px-2 py-1 fw-semibold text-break">

                                                                    {assignmentData?.booksTypeId === 1 && <> Kindle {assignmentData?.book?.kindle_asin}</>}
                                                                    {assignmentData?.booksTypeId === 2 && <> Paperback {assignmentData?.book?.paper_back_asin}</>}
                                                                    {assignmentData?.booksTypeId === 3 && <> Hardcover {assignmentData?.book?.hard_cover_asin}</>}
                                                                    {assignmentData?.booksTypeId === 4 && <> Audio {assignmentData?.book?.audio_asin || assignmentData?.book?.audio_audible_asin}</>}
                                                                    {(assignmentData?.booksTypeId === 5 || assignmentData?.booksTypeId === 6) && <> Any {assignmentData?.book?.kindle_asin || assignmentData?.book?.paper_back_asin || assignmentData?.book?.hard_cover_asin|| assignmentData?.book?.audio_asin || assignmentData?.book?.audio_audible_asin}</>}
                                                                {/* ✅ 7 — Product */}
                                                                {assignmentData?.booksTypeId === 7 && (
                                                                    <> Product {assignmentData?.book?.kindle_asin} </>
                                                                )}

                                                                {/* ✅ 8 —  */}
                                                                {assignmentData?.booksTypeId === 8 && (
                                                                    <> Product {assignmentData?.book?.paper_back_asin} </>
                                                                )}

                                                                {/* ✅ 9 — Product  */}
                                                                {assignmentData?.booksTypeId === 9 && (
                                                                    <> Product Variant {assignmentData?.book?.hard_cover_asin} </>
                                                                )}

                                                                {/* ✅ 10 — Product  */}
                                                                {assignmentData?.booksTypeId === 10 && (
                                                                    <> Product {assignmentData?.book?.audio_asin} </>
                                                                )}
                                                            </td>
                                                            <td className="px-2 py-1 fw-semibold">{typeLabel}</td>
                                                            <td className="px-2 py-1 fw-semibold">
                                                                <Button variant="success" size="sm" onClick={handleConfirmNoReview}>
                                                                    Confirm
                                                                </Button>
                                                                <Button variant="danger" size="sm" className="ms-2" onClick={handleDecline}>
                                                                    Decline
                                                                </Button>
                                                            </td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div>

                                            </div>

                                            {/* Mobile (< md): компактная карточка */}
                                            <div className="d-md-none">
                                                <div className="border rounded p-2 bg-white small">
                                                    <div className="d-flex justify-content-between py-1 border-bottom">
                                                        <span className="text-muted">Reviewer</span>
                                                        <span className="fw-semibold ms-2 text-end">
                      {assignmentData?.checked_review_name || reviewData?.review_name || "No Name"}
                    </span>
                                                    </div>
                                                    <div className="d-flex justify-content-between py-1 border-bottom">
                                                        <span className="text-muted">ExpR</span>
                                                        <span className="fw-semibold ms-2 text-end">
                      {assignmentData?.rating || reviewData?.review_rating || "N/A"}
                    </span>
                                                    </div>
                                                    <div className="d-flex justify-content-between py-1 border-bottom">
                                                        <span className="text-muted">ASIN</span>
                                                        <span className="fw-semibold ms-2 text-end text-break">
                      {assignmentData?.checked_asin || reviewData?.asin || "No ASIN"}
                    </span>
                                                    </div>
                                                    <div className="d-flex justify-content-between py-1">
                                                        <span className="text-muted">Type</span>
                                                        <span className="fw-semibold ms-2 text-end">{typeLabel}</span>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Две фото из БД */}
                                            {hasProofs && (
                                                <>
                                                    <div className="d-flex align-items-center justify-content-between gap-2 flex-wrap">
                                                        <strong className="text-muted me-2">{proofLabel}</strong>
                                                        {!isSingleProofAssignment && showProofModerationActions && (
                                                            <span className="d-flex align-items-center gap-2">
                                                                <Button
                                                                    variant="success"
                                                                    size="sm"
                                                                    disabled={loading}
                                                                    onClick={handleProofApprove}
                                                                >
                                                                    Approve
                                                                </Button>
                                                                <Button
                                                                    variant="outline-danger"
                                                                    size="sm"
                                                                    disabled={loading}
                                                                    onClick={handleProofReject}
                                                                >
                                                                    Reject
                                                                </Button>
                                                            </span>
                                                        )}
                                                    </div>
                                                    <div
                                                        className="mt-2"
                                                        style={{
                                                            display: "grid",
                                                            gridTemplateColumns: proofUrls.length > 1 ? "repeat(auto-fit, minmax(220px, 1fr))" : "minmax(0, 420px)",
                                                            justifyContent: "start",
                                                            gap: 12,
                                                            width: "100%",
                                                        }}
                                                    >
                                                        {proofUrls.map((url, idx) => (
                                                            <ProofImageCard
                                                                key={`proof-${idx}`}
                                                                src={url}
                                                                alt={`Proof ${idx + 1}`}
                                                                fallbackSrc={proofFallback}
                                                            />
                                                        ))}
                                                    </div>
                                                </>
                                            )}
                                        </>
                                    ) : (
                                        /* ====== ORIGINAL (FULL) MODE FOR OTHER TYPES ====== */
                                        <>
                                            {/* Desktop/Tablet (>= md): таблица */}
                                            <div className="d-none d-md-block">
                                                <div className="table-responsive">
                                                    <table className="table table-sm table-bordered align-middle small mb-2">
                                                        <thead className="bg-secondary bg-opacity-50 text-sm">
                                                        <tr>
                                                            <th className="px-2 py-1">Reviewer</th>
                                                            <th className="px-2 py-1">ExpR</th>
                                                            <th className="px-2 py-1">FindR</th>
                                                            <th className="px-2 py-1">Date</th>
                                                            <th className="px-2 py-1">Country</th>
                                                            <th className="px-2 py-1">ASIN</th>
                                                            <th className="px-2 py-1">Type</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        <tr>
                                                            <td className="px-2 py-1 fw-semibold">
                                                                {assignmentData?.checked_review_name || reviewData?.review_name || "No Name"}
                                                            </td>
                                                            <td className="px-2 py-1 fw-semibold">
                                                                {assignmentData?.rating || reviewData?.rating || "No Rating"}
                                                            </td>
                                                            <td className="px-2 py-1 fw-semibold">
                                                                {assignmentData?.checked_review_rating || reviewData?.review_rating || "N/A"}
                                                            </td>
                                                            <td className="px-2 py-1 fw-semibold">
                                                                {assignmentData?.checked_review_date || reviewData?.review_date || "N/A"}
                                                            </td>
                                                            <td className="px-2 py-1 fw-semibold">
                                                                {assignmentData?.checked_review_country || reviewData?.review_country || "N/A"}
                                                            </td>
                                                            <td className="px-2 py-1 fw-semibold text-break">
                                                                {assignmentData?.checked_asin || reviewData?.asin || "No ASIN"}
                                                            </td>
                                                            <td className="px-2 py-1 fw-semibold">{typeLabel}</td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>

                                            {/* Mobile (< md): карточка */}
                                            <div className="d-md-none">
                                                <div className="border rounded p-2 bg-white small">
                                                    <div className="d-flex justify-content-between py-1 border-bottom">
                                                        <span className="text-muted">Reviewer</span>
                                                        <span className="fw-semibold ms-2 text-end">
                      {assignmentData?.checked_review_name || reviewData?.review_name || "No Name"}
                    </span>
                                                    </div>
                                                    <div className="d-flex justify-content-between py-1 border-bottom">
                                                        <span className="text-muted">ExpR</span>
                                                        <span className="fw-semibold ms-2 text-end">
                      {assignmentData?.rating || reviewData?.review_rating || "No Rating"}
                    </span>
                                                    </div>
                                                    <div className="d-flex justify-content-between py-1 border-bottom">
                                                        <span className="text-muted">FindR</span>
                                                        <span className="fw-semibold ms-2 text-end">
                      {assignmentData?.checked_review_rating || reviewData?.review_rating || "N/A"}
                    </span>
                                                    </div>
                                                    <div className="d-flex justify-content-between py-1 border-bottom">
                                                        <span className="text-muted">Date</span>
                                                        <span className="fw-semibold ms-2 text-end">
                      {assignmentData?.checked_review_date || reviewData?.review_date || "N/A"}
                    </span>
                                                    </div>
                                                    <div className="d-flex justify-content-between py-1 border-bottom">
                                                        <span className="text-muted">Country</span>
                                                        <span className="fw-semibold ms-2 text-end">
                      {assignmentData?.checked_review_country || reviewData?.review_country || "N/A"}
                    </span>
                                                    </div>
                                                    <div className="d-flex justify-content-between py-1 border-bottom">
                                                        <span className="text-muted">ASIN</span>
                                                        <span className="fw-semibold ms-2 text-end text-break">
                      {assignmentData?.checked_asin || reviewData?.asin || "No ASIN"}
                    </span>
                                                    </div>
                                                    <div className="d-flex justify-content-between py-1">
                                                        <span className="text-muted">Type</span>
                                                        <span className="fw-semibold ms-2 text-end">{typeLabel}</span>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Title & Text — показываем ТОЛЬКО в полном режиме */}
                                            <Row className="mt-2">
                                                <Col>
                                                    <strong className="text-muted mt-2">Title of Review:</strong>
                                                    <p className="me-2 mb-1 mt-0 fst-italic text-muted" style={{ lineHeight: "1" }}>
                                                        {assignmentData?.checked_review_title || reviewData?.review_title || "No Title"}
                                                    </p>
                                                </Col>
                                            </Row>

                                            <strong className="text-muted">Text of Review: </strong>
                                            <p className="text-dark text-muted fst-italic small" style={{ lineHeight: "1.2" }}>
                                                {assignmentData?.checked_review_text || reviewData?.review_text || "No Text"}
                                                <br />
                                            </p>

                                            {/* Media in Review — как было */}
                                            {(assignmentData?.checked_review_photo ||
                                                assignmentData?.checked_review_photo2 ||
                                                assignmentData?.checked_review_photo3 ||
                                                assignmentData?.checked_review_photo4 ||
                                                assignmentData?.checked_review_photo5 ||
                                                reviewData?.review_photo ||
                                                reviewData?.review_photo2 ||
                                                reviewData?.review_photo3 ||
                                                reviewData?.review_photo4 ||
                                                reviewData?.review_photo5) && (
                                                <>
                                                    <strong className="text-muted me-2">Media in Review:</strong>
                                                    {(() => {
                                                        const isVideoUrl = (u = "") =>
                                                            /\.mp4(\?|$)/i.test(u) || u?.includes("/vse-vms-transcoding-artifact-");

                                                        const mediaUrls = [
                                                            buildPhotoUrl(assignmentData?.checked_review_photo),
                                                            buildPhotoUrl(assignmentData?.checked_review_photo2),
                                                            buildPhotoUrl(assignmentData?.checked_review_photo3),
                                                            buildPhotoUrl(assignmentData?.checked_review_photo4),
                                                            buildPhotoUrl(assignmentData?.checked_review_photo5),
                                                            reviewData?.review_photo,
                                                            reviewData?.review_photo2,
                                                            reviewData?.review_photo3,
                                                            reviewData?.review_photo4,
                                                            reviewData?.review_photo5,
                                                        ].filter(Boolean);

                                                        const unique = Array.from(new Set(mediaUrls));

                                                        const poster =
                                                            reviewData?.review_photo2 ||
                                                            reviewData?.review_photo3 ||
                                                            reviewData?.review_photo4 ||
                                                            reviewData?.review_photo5 ||
                                                            (!isVideoUrl(assignmentData?.checked_review_photo) && assignmentData?.checked_review_photo) ||
                                                            "";

                                                        return (
                                                            <div className="d-flex align-items-center flex-nowrap overflow-auto" style={{ gap: 8 }}>
                                                                {unique.map((url, idx) =>
                                                                    isVideoUrl(url) ? (
                                                                        <video
                                                                            key={`media-${idx}`}
                                                                            src={url}
                                                                            preload="metadata"
                                                                            controls
                                                                            className="shadow rounded"
                                                                            style={{ width: 300, borderRadius: 6 }}
                                                                            onError={(e) => {
                                                                                e.currentTarget.outerHTML = `
                                  <img 
                                    src="${process.env.REACT_APP_API_URL}covers/empty-cover.jpg" 
                                    style="width:160px; object-fit:cover; border-radius:6px" 
                                    class="shadow"
                                    alt="Fallback"
                                  />`;
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        <img
                                                                            key={`media-${idx}`}
                                                                            src={url}
                                                                            alt={`Review Media ${idx + 1}`}
                                                                            className="shadow"
                                                                            style={{ width: 160, objectFit: "cover", borderRadius: 6, cursor: "zoom-in" }}
                                                                            onError={(e) => {
                                                                                e.currentTarget.onerror = null;
                                                                                e.currentTarget.src = `${process.env.REACT_APP_API_URL}covers/empty-cover.jpg`;
                                                                            }}
                                                                            onClick={() => setFullImage(url)}
                                                                        />
                                                                    )
                                                                )}
                                                            </div>
                                                        );
                                                    })()}
                                                </>
                                            )}

                                            {/* Link */}
                                            <h6 className="mt-1 text-muted">
                                                <button
                                                    type="button"
                                                    className="text-break d-none d-md-inline"
                                                    style={{ border: 0, padding: 0, background: "transparent", color: "inherit", textAlign: "left" }}
                                                    onClick={() => openRedirectedLink(assignmentData?.review_link)}
                                                >
                                                    <strong>{assignmentData?.review_link}</strong>
                                                </button>
                                                <button
                                                    type="button"
                                                    className="d-inline d-md-none"
                                                    style={{ border: 0, padding: 0, background: "transparent", color: "inherit", textAlign: "left" }}
                                                    onClick={() => openRedirectedLink(assignmentData?.review_link)}
                                                >
                                                    <strong>Check Review</strong>
                                                </button>
                                            </h6>

                                            {/* Penalty Log */}
                                            <h6 className="mt-1 text-muted">
                                                Penalty Log: {assignmentData?.checked_review_log || "No Penalty Log"}
                                            </h6>
                                        </>
                                    )}
                                </Col>
                            </Row>
                        </>
                    );
                })()}




                <Row className="g-2 mt-2 w-100">
                    {/* ✅ Первая колонка (6) */}
                    <Col md={12} className="justify-content-start small" >
                        <ListGroup
                            variant="success"
                            className="d-flex flex-row flex-wrap align-items-center gap-1 border rounded p-2"
                        >
                            <ListGroup.Item style={{ paddingTop: "0.10rem", paddingBottom: "0.10rem" }}>
                                <p className="me-2 mb-0 fst-italic mt-0 text-muted">
                                    <FaBookOpen className="me-2" />
                                    BT:
                                    <strong>
                                        {assignmentData?.booksTypeId === 1 && <> Kindle {assignmentData?.book?.kindle_asin}</>}
                                        {assignmentData?.booksTypeId === 2 && <> Paperback {assignmentData?.book?.paper_back_asin}</>}
                                        {assignmentData?.booksTypeId === 3 && <> Hardcover {assignmentData?.book?.hard_cover_asin}</>}
                                        {assignmentData?.booksTypeId === 4 && <> Audio {assignmentData?.book?.audio_asin || assignmentData?.book?.audio_audible_asin}</>}
                                        {(assignmentData?.booksTypeId === 5 || assignmentData?.booksTypeId === 6) && <> Any {assignmentData?.book?.kindle_asin || assignmentData?.book?.paper_back_asin || assignmentData?.book?.hard_cover_asin|| assignmentData?.book?.audio_asin || assignmentData?.book?.audio_audible_asin}</>}
                                        {/* ✅ 7 — Product */}
                                        {assignmentData?.booksTypeId === 7 && (
                                            <> Product {assignmentData?.book?.kindle_asin} </>
                                        )}

                                        {/* ✅ 8 —  */}
                                        {assignmentData?.booksTypeId === 8 && (
                                            <> Product {assignmentData?.book?.paper_back_asin} </>
                                        )}

                                        {/* ✅ 9 — Product  */}
                                        {assignmentData?.booksTypeId === 9 && (
                                            <> Product Variant {assignmentData?.book?.hard_cover_asin} </>
                                        )}

                                        {/* ✅ 10 — Product  */}
                                        {assignmentData?.booksTypeId === 10 && (
                                            <> Product {assignmentData?.book?.audio_asin} </>
                                        )}
                                    </strong>

                                </p>
                            </ListGroup.Item>

                            <ListGroup.Item style={{ paddingTop: "0.10rem", paddingBottom: "0.10rem" }}>
                                <p className="me-2 mb-0 fst-italic mt-0 text-muted">
                                    <FaTasks className="me-2" />
                                    AT:
                                    <strong>
                                        {assignmentData?.assTypeId === 1 && " Universal Assignment"}
                                        {assignmentData?.assTypeId === 2 && " Kindle Unlimited"}
                                        {assignmentData?.assTypeId === 3 && " Verified Purchase"}
                                        {assignmentData?.assTypeId === 4 && " Verified Purchase Img"}
                                        {assignmentData?.assTypeId === 5 && " Ver/Pur Search&Buy"}
                                        {assignmentData?.assTypeId === 6 && " Ver/Pur Search&Buy Img"}
                                        {assignmentData?.assTypeId === 7 && " Universal Audio"}
                                        {assignmentData?.assTypeId === 8 && " Audible Promo Code"}
                                        {assignmentData?.assTypeId === 9 && " Verified Kindle Unlimited"}

                                        {assignmentData?.assTypeId === 10 && " Paperback BuyOut"}
                                        {assignmentData?.assTypeId === 11 && " PB Search&BuyOut"}
                                        {assignmentData?.assTypeId === 12 && " PB Verified + Img"}
                                        {assignmentData?.assTypeId === 13 && " PB Verified + Video"}

                                        {assignmentData?.assTypeId === 14 && " Hardcover BuyOut"}
                                        {assignmentData?.assTypeId === 15 && " HC Search&BuyOut"}
                                        {assignmentData?.assTypeId === 16 && " HC Verified + Img"}
                                        {assignmentData?.assTypeId === 17 && " HC Verified + Video"}

                                        {assignmentData?.assTypeId === 18 && " PB Verified Purchase"}
                                        {assignmentData?.assTypeId === 19 && " PB Verified Search&Buy"}
                                        {assignmentData?.assTypeId === 20 && " HC Verified Purchase"}
                                        {assignmentData?.assTypeId === 21 && " HC Verified Search&Buy"}

                                        {assignmentData?.assTypeId === 22 && " Product BuyOut"}
                                        {assignmentData?.assTypeId === 23 && " Product Search&BuyOut"}
                                        {assignmentData?.assTypeId === 24 && " Product Verified"}
                                        {assignmentData?.assTypeId === 25 && " Product Verified + Img"}
                                        {assignmentData?.assTypeId === 26 && " Product Verified + Video"}
                                        {assignmentData?.assTypeId === 27 && " Product Verified Search&Buy"}

                                        {assignmentData?.assTypeId === 28 && " Make Helpful Internal"}
                                        {assignmentData?.assTypeId === 29 && " Write Report Internal"}
                                        {assignmentData?.assTypeId === 30 && " Make Helpful External"}
                                        {assignmentData?.assTypeId === 31 && " Write Report External"}
                                        {assignmentData?.assTypeId === 32 && " Set Stars Rating"}

                                    </strong>
                                </p>
                            </ListGroup.Item>
                            <ListGroup.Item style={{ paddingTop: "0.10rem", paddingBottom: "0.10rem" }}>
                                <p className="me-2 mb-0 fst-italic mt-0 text-muted">
                                    <FaMoneyBillWave className="me-2" />
                                    Spends:
                                    <strong>
                                        {(assignmentData?.assTypeId >= 10 && assignmentData?.assTypeId <= 17)
                                            ? ` $${(+assignmentData?.book_cost_compensation || 0).toFixed(2)}`
                                            : (
                                                assignmentData?.booksPriceId === 1 ? " FREE" :
                                                    assignmentData?.booksPriceId === 2 ? " $0.99" :
                                                        assignmentData?.booksPriceId === 3 ? " $1.99" :
                                                            assignmentData?.booksPriceId === 4 ? " $2.99" :
                                                                assignmentData?.booksPriceId === 5 ? " $3.99" :
                                                                    assignmentData?.booksPriceId === 6 ? " $4.99" :
                                                                        assignmentData?.booksPriceId === 7 ? " $5.99" :
                                                                            assignmentData?.booksPriceId === 8 ? " $6.99" : ""
                                            )
                                        }
                                    </strong>

                                </p>
                            </ListGroup.Item>
                            <ListGroup.Item style={{ paddingTop: "0.10rem", paddingBottom: "0.10rem" }}>
                                <p className="me-2 mb-0 fst-italic mt-0 text-muted">
                                    <FaCoins className="me-2" />
                                    Reader Earnings: <strong>{assignmentData?.assignment_price_reader} Virt
                                    {assignmentData?.received_bonus > 0 && (" + " + assignmentData?.received_bonus + " Virt")} (ID: {assignmentData?.reviewer_id})</strong>
                                </p>
                            </ListGroup.Item>
                            <ListGroup.Item style={{ paddingTop: "0.10rem", paddingBottom: "0.10rem" }}>
                                <p className="me-2 mb-0 fst-italic mt-0 text-muted">
                                    <FaSearchDollar className="me-2" />
                                    Publisher Spends: <strong>{assignmentData?.assignment_price_publisher} Virt (ID: {assignmentData?.userId})</strong>
                                </p>
                            </ListGroup.Item>
                            <ListGroup.Item style={{ paddingTop: "0.10rem", paddingBottom: "0.10rem" }}>
                                <p className="me-2 mb-0 fst-italic  mt-0 text-muted">
                                    Expected reviewer:<strong>  {expectedReviewerName || "No Reviewer for now"} (ID: {assignmentData?.reviewer_id})</strong>
                                </p>
                            </ListGroup.Item>
                            <ListGroup.Item style={{ paddingTop: "0.10rem", paddingBottom: "0.10rem" }}>
                                <p className="me-2 mb-0 fst-italic  mt-0 text-muted">
                                    Current Reviewer:<strong>  {reviewerData?.amz_name || "No Reviewer for now"} (ID: {assignmentData?.reviewer_id})</strong>
                                </p>
                            </ListGroup.Item>
                            <ListGroup.Item style={{ paddingTop: "0.10rem", paddingBottom: "0.10rem" }}>
                                <p className="me-2 mb-0 fst-italic  mt-0 text-muted">
                                    Confirmed R:<strong>  {assignmentData?.checked_review_name || "No Reviewer for now"} (ID: {assignmentData?.reviewer_id})</strong>
                                </p>
                            </ListGroup.Item>
                            <ListGroup.Item style={{ paddingTop: "0.10rem", paddingBottom: "0.10rem" }}>
                                <p className="me-2 mb-0 fst-italic mt-0 text-muted">
                                    Start Review Date:
                                    <strong>
                                        {" "}
                                        {assignmentData?.start_rev_date
                                            ? new Date(assignmentData.start_rev_date * 60000).toLocaleDateString("en-GB", { day: "2-digit", month: "long", year: "numeric" })
                                            : "—"}
                                    </strong>
                                </p>
                            </ListGroup.Item>

                            <ListGroup.Item style={{ paddingTop: "0.10rem", paddingBottom: "0.10rem" }}>
                                <p className="me-2 mb-0 fst-italic mt-0 text-muted">
                                    Start Reading Date:
                                    <strong>
                                        {" "}
                                        {assignmentData?.start_read_date
                                            ? new Date(assignmentData.start_read_date * 60000).toLocaleDateString("en-GB", { day: "2-digit", month: "long", year: "numeric" })
                                            : "—"}
                                    </strong>
                                </p>
                            </ListGroup.Item>

                            <ListGroup.Item style={{ paddingTop: "0.10rem", paddingBottom: "0.10rem" }}>
                                <p className="me-2 mb-0 fst-italic mt-0 text-muted">
                                    Published Review Date:
                                    <strong>
                                        {" "}
                                        {assignmentData?.publish_rev_date
                                            ? new Date(assignmentData.publish_rev_date * 60000).toLocaleDateString("en-GB", { day: "2-digit", month: "long", year: "numeric" })
                                            : "—"}
                                    </strong>
                                </p>
                            </ListGroup.Item>

                            <ListGroup.Item style={{ paddingTop: "0.10rem", paddingBottom: "0.10rem" }}>
                                <p className="me-2 mb-0 fst-italic mt-0 text-muted">
                                    Confirmed (End) Date:
                                    <strong>
                                        {" "}
                                        {assignmentData?.end_rev_date
                                            ? new Date(assignmentData.end_rev_date * 60000).toLocaleDateString("en-GB", { day: "2-digit", month: "long", year: "numeric" })
                                            : "—"}
                                    </strong>
                                </p>
                            </ListGroup.Item>
                            <ListGroup.Item style={{ paddingTop: "0.10rem", paddingBottom: "0.10rem" }}>
                                <p className="me-2 mb-0 fst-italic mt-0 text-danger fw-semibold">
                                    Why not 5:
                                    <strong> {assignmentData.why_not_5_text || "No Why not 5 Text"}</strong>
                                </p>
                            </ListGroup.Item>

                        </ListGroup>

                        <Card className="d-none mt-1 p-0 border border-secondary shadow-sm rounded">
                            <Card.Body>
                        <h6 className="mt-0 mb-0">Balance Update:</h6>
                        <div className="d-flex align-items-end gap-3 my-1 mt-1 flex-wrap">

                            {/* Author */}
                            <div className="d-flex flex-column">
                                <label className="form-label small mb-1">Author</label>
                                <input
                                    type="number"
                                    className="form-control form-control-sm"
                                    style={{ width: "100px" }}
                                    value={authorAmount}
                                    onChange={(e) => setAuthorAmount(e.target.value)}
                                />
                            </div>

                            {/* Reviewer */}
                            <div className="d-flex flex-column">
                                <label className="form-label small mb-1">Reviewer</label>
                                <input
                                    type="number"
                                    className="form-control form-control-sm"
                                    style={{ width: "100px" }}
                                    value={reviewerAmount}
                                    onChange={(e) => setReviewerAmount(e.target.value)}
                                />
                            </div>

                            {/* Button */}
                            <div>
                                <button
                                    className="btn btn-outline-success btn-sm"
                                    onClick={handleClick}
                                >
                                    Change
                                </button>
                            </div>

                        </div>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={8} className="d-none justify-content-start small" >
                        <div style={{ overflowX: 'auto', whiteSpace: 'nowrap', paddingBottom: '8px' }}>
                            <Table bordered hover size="sm" striped className="mt-1 mb-1" style={{ minWidth: '500px', lineHeight: '1.3' }}>
                                <thead className="table-light text-muted small">
                                <tr>
                                    <th className="ps-2">Parameter</th>
                                    <th className="ps-2">Reviewer</th>
                                    <th className="ps-2">Publisher</th>
                                </tr>
                                </thead>
                                <tbody>
                                {[
                                    ["User ID", reviewerData?.userId, ownerData?.userId],
                                    ["Username", reviewerData?.username, ownerData?.username],
                                    ["E-Mail", reviewerData?.email, ownerData?.email],
                                    ["Amazon Name", reviewerData?.amz_name, ownerData?.amz_name],
                                    ["Audible Name", reviewerData?.audible_name, ownerData?.audible_name],
                                    ["Balance", reviewerData?.balance, ownerData?.balance],
                                    ["LR Balance", assignmentData?.reviewer?.lr_balance, assignmentData?.owner?.lr_balance],
                                    ["Affiliate Balance", assignmentData?.reviewer?.affiliate_balance, assignmentData?.owner?.affiliate_balance],

                                    [
                                        "Registration Date",
                                        assignmentData?.reviewer?.registration_date
                                            ? new Date(assignmentData.reviewer.registration_date * 60000).toLocaleDateString("en-GB", { day: "2-digit", month: "long", year: "numeric" })
                                            : "—",
                                        assignmentData?.owner?.registration_date
                                            ? new Date(assignmentData.owner.registration_date * 60000).toLocaleDateString("en-GB", { day: "2-digit", month: "long", year: "numeric" })
                                            : "—",
                                    ],
                                    ["Tariff Plan", reviewerData?.tariff_plan, ownerData?.tariff_plan],
                                    ["Level of Trust", reviewerData?.level_of_trust, ownerData?.level_of_trust],
                                    ["Amazon Country", reviewerData?.amz_country, ownerData?.amz_country],
                                    ["Audible Country", reviewerData?.audible_country, ownerData?.audible_country],
                                    ["Posted Assignments", reviewerData?.postedAss, ownerData?.postedAss],
                                    ["Took Assignments", reviewerData?.compiledAss, ownerData?.compiledAss],
                                    ["Affiliate Model", assignmentData?.reviewer?.affiliate_model, assignmentData?.owner?.affiliate_model],
                                    ["Amazon RN Changes", assignmentData?.reviewer?.amazon_rn_changes, assignmentData?.owner?.amazon_rn_changes],
                                    ["Audible RN Changes", assignmentData?.reviewer?.audible_rn_changes, assignmentData?.owner?.audible_rn_changes],
                                ].map(([label, revVal, ownVal]) => (
                                    <tr key={label} className="fst-italic" style={{ lineHeight: "1", padding: "2px 0" }}>
                                        <td className="ps-2">{label}</td>
                                        <td className="ps-2">{revVal ?? "—"}</td>
                                        <td className="ps-2">{ownVal ?? "—"}</td>
                                    </tr>
                                ))}
                                </tbody>
                            </Table>

                            <span className="text-danger ms-2 fw-semibold">{assignmentData.why_not_5_text || "No Why not 5 Text"}</span>
                        </div>
                    </Col>
                </Row>


                <div
                    className="border-top mt-3 pt-2 mb-2 d-flex flex-wrap gap-2 align-items-center bg-white"
                    style={{ position: "sticky", top: 0, zIndex: 10 }}
                >
                    <Button
                        variant="outline-secondary"
                        size="sm"
                        onClick={getALogs}
                        disabled={loadingId !== null}
                    >
                        {loadingId === "authorLogs" ? (
                            <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true" />
                        ) : null}
                        Author Logs
                    </Button>
                    <Button
                        variant="outline-secondary"
                        size="sm"
                        onClick={getRLogs}
                        disabled={loadingId !== null}
                    >
                        {loadingId === "reviewerLogs" ? (
                            <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true" />
                        ) : null}
                        Reviewer Logs
                    </Button>
                    <Button
                        variant="outline-danger"
                        size="sm"
                        onClick={() => getLinked(assignmentData?.userId)}
                        disabled={loadingId !== null || !assignmentData?.userId}
                    >
                        {loadingId === `fraud:${assignmentData?.userId}` ? (
                            <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true" />
                        ) : null}
                        Check Author Anti-Fraud
                    </Button>
                    <Button
                        variant="outline-danger"
                        size="sm"
                        onClick={() => getLinked(assignmentData?.reviewer_id)}
                        disabled={loadingId !== null || !assignmentData?.reviewer_id}
                    >
                        {loadingId === `fraud:${assignmentData?.reviewer_id}` ? (
                            <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true" />
                        ) : null}
                        Check Reviewer Anti-Fraud
                    </Button>
                    <Button variant="outline-secondary" size="sm" onClick={clearLogs}>
                        Clear
                    </Button>
                </div>




                {reviewData && (
                    <div className="card mt-4">
                        <div className="card-body">
                            <h5 className="card-title">Review Data</h5>
                            <div className="table-responsive">
                                <table className="table table-sm table-striped align-middle mb-0">
                                    <tbody>
                                    {Object.entries(reviewData).map(([key, value]) => (
                                        <tr key={key} style={{ lineHeight: '1', height: '30px' }}>
                                            <th className="text-secondary small py-1" style={{ minWidth: '160px' }}>
                                                {key.replace(/_/g, ' ')}
                                            </th>
                                            <td
                                                className="text-truncate small px-2 py-1"
                                                style={{ maxWidth: '100%', overflowX: 'auto' }}
                                            >
                                                {key.startsWith('review_photo')
                                                    ? renderMediaThumb(key, value, reviewData)
                                                    : value?.toString()
                                                }
                                            </td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                )}


                {/* + NEW: Anti-Fraud results */}
                {linkedError && (
                    <div className="alert alert-danger mt-3 py-2 px-3 small">
                        {linkedError}
                    </div>
                )}

                {linked && (
                    <div className="mt-3">
                        <h6 className="mb-2">
                            Anti-Fraud Matches:
                            <span className="ms-2 text-muted small">
        Source User: {linked.source_user_id} • Lookback: {linked.lookback_days} days • Min signals: {linked.min_signals} • Total: {linked.total_matches}
      </span>
                        </h6>

                        {/* Desktop table */}
                        <div className="d-none d-md-block">
                            <Table bordered hover size="sm" striped className="mt-1" style={{ minWidth: '600px' }}>
                                <thead className="table-light small">
                                <tr>
                                    <th className="text-nowrap small">ID</th>
                                    <th className="small">Username</th>
                                    <th>AMZ Name</th>
                                    <th>Matched Fields</th>
                                    <th className="text-nowrap small">Counts per Field</th>
                                    <th className="text-center small text-nowrap">Hits</th>
                                    <th className="text-nowrap small">First Seen</th>
                                    <th className="text-nowrap small">Last Seen</th>
                                    <th className="text-end small text-nowrap">Weight</th>
                                </tr>
                                </thead>
                                <tbody>
                                {(linked.results || []).map((r, idx) => {
                                    const counts = Object.entries(r.counts_per_field || {}).map(([k,v]) => `${k}: ${v}`).join(', ');
                                    return (
                                        <tr key={`${r.other_user_id ?? 'guest'}-${idx}`} className="small">
                                            <td className="text-nowrap small">{r.other_user_id ?? <span className="text-muted">guest</span>}</td>
                                            <td className="small">{r.user?.username || <span className="text-muted">—</span>}</td>
                                            <td className="small">{r.user?.amz_name || <span className="text-muted">—</span>}</td>
                                            <td className="small" style={{maxWidth: 260}}>
                                                <div className="text-truncate" title={(r.matched_fields || []).join(', ')}>
                                                    {(r.matched_fields || []).join(', ')}
                                                </div>
                                            </td>
                                            <td className="small" style={{maxWidth: 300}}>
                                                <div className="text-truncate" title={counts}>{counts}</div>
                                            </td>
                                            <td className="text-center small">{r.total_hits}</td>
                                            <td className="text-nowrap small">
                                                {new Date(r.first_seen_at).toLocaleString("en-GB", { day:"2-digit", month:"short", year:"numeric", hour:"2-digit", minute:"2-digit" })}
                                            </td>
                                            <td className="text-nowrap small">
                                                {new Date(r.last_seen_at).toLocaleString("en-GB", { day:"2-digit", month:"short", year:"numeric", hour:"2-digit", minute:"2-digit" })}
                                            </td>
                                            <td className="text-end small">{r.suspicion_weight}</td>
                                        </tr>
                                    );
                                })}
                                </tbody>
                            </Table>
                        </div>

                        {/* Mobile cards */}
                        <div className="d-block d-md-none">
                            {(linked.results || []).map((r, idx) => (
                                <div key={`${r.other_user_id ?? 'guest'}-m-${idx}`} className="card mb-2 shadow-sm border border-secondary small">
                                    <div className="card-body p-2">
                                        <div className="d-flex justify-content-between">
                                            <strong>Other ID:</strong> <span>{r.other_user_id ?? 'guest'}</span>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                            <strong>Username:</strong> <span>{r.user?.username || '—'}</span>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                            <strong>AMZ:</strong> <span>{r.user?.amz_name || '—'}</span>
                                        </div>
                                        <div className="mt-1">
                                            <strong>Fields:</strong>
                                            <div className="text-muted">{(r.matched_fields || []).join(', ') || '—'}</div>
                                        </div>
                                        <div className="mt-1">
                                            <strong>Counts:</strong>
                                            <div className="text-muted">
                                                {Object.entries(r.counts_per_field || {}).map(([k,v]) => `${k}: ${v}`).join(', ') || '—'}
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-between mt-1">
                                            <strong>Hits:</strong> <span>{r.total_hits}</span>
                                        </div>
                                        <div className="d-flex justify-content-between mt-1">
                                            <strong>First:</strong>
                                            <span>{new Date(r.first_seen_at).toLocaleString("en-GB", { day:"2-digit", month:"short", year:"numeric", hour:"2-digit", minute:"2-digit" })}</span>
                                        </div>
                                        <div className="d-flex justify-content-between mt-1">
                                            <strong>Last:</strong>
                                            <span>{new Date(r.last_seen_at).toLocaleString("en-GB", { day:"2-digit", month:"short", year:"numeric", hour:"2-digit", minute:"2-digit" })}</span>
                                        </div>
                                        <div className="d-flex justify-content-between mt-1">
                                            <strong>Weight:</strong> <span>{r.suspicion_weight}</span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Empty state */}
                        {Array.isArray(linked.results) && linked.results.length === 0 && (
                            <div className="alert alert-light border mt-2 py-2 px-3 small">
                                No intersections found.
                            </div>
                        )}
                    </div>
                )}





                {logs.length > 0 && (
                    <div className="mt-2">
                        <h6>Assignment Logs:</h6>

                        {/* Desktop / Tablet */}
                        <div className="d-none d-md-block">
                            <div className="table-responsive">
                                <Table bordered hover size="sm" striped className="mt-1" style={{ minWidth: '600px' }}>
                                    <thead className="table-light small">
                                    <tr>
                                        <th className="small">ID</th>
                                        <th className="small">UID</th>
                                        <th className="small">AName</th>
                                        <th className="small">Amount</th>
                                        <th className="small">Balance</th>
                                        <th className="small">Description</th>
                                        <th className="small">Created</th>
                                        <th className="small">Type</th>

                                    </tr>
                                    </thead>
                                    <tbody>
                                    {logs.map((log) => (
                                        <tr key={log.id} className="small">
                                            <td className="small">{log.id}</td>
                                            <td className="small">{log.user_id}</td>
                                            <td className="text-nowrap small">{log.user_amz_name}</td>
                                            <td className={Number(log.amount) < 0 ? "text-danger small fw-semibold" : "text-success small fw-semibold"}>
                                                {log.amount}
                                            </td>
                                            <td className="small">{log.balance_state}</td>
                                            <td className="text-break small">{log.description}</td>
                                            <td className="text-nowrap small">
                                                {new Date(log.createdAt).toLocaleString('en-GB', {
                                                    day: '2-digit',
                                                    month: 'short',
                                                    year: 'numeric',
                                                    hour: '2-digit',
                                                    minute: '2-digit',
                                                    hour12: false
                                                })}
                                            </td>
                                            <td className="align-middle text-center small text-nowrap">
                                                {log.log_type}
                                            </td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </Table>
                            </div>
                        </div>

                        {/* Mobile */}
                        <div className="d-md-none">
                            <div className="d-flex flex-column gap-2">
                                {logs.map((log) => (
                                    <div key={log.id} className="border border-secondary shadow-sm rounded p-2 bg-white small">
                                        <div className="d-flex justify-content-between">
                                            <span className="text-muted">ID</span>
                                            <span className="fw-semibold ms-2">{log.id}</span>
                                        </div>

                                        <div className="d-flex justify-content-between">
                                            <span className="text-muted">UID</span>
                                            <span className="ms-2">{log.user_id}</span>
                                        </div>

                                        <div className="d-flex justify-content-between">
                                            <span className="text-muted">AName</span>
                                            <span className="ms-2 text-end text-truncate" style={{ maxWidth: '60%' }}>
                {log.user_amz_name}
              </span>
                                        </div>

                                        <div className="d-flex justify-content-between">
                                            <span className="text-muted">Amount</span>
                                            <span
                                                className={
                                                    "ms-2 fw-semibold " + (Number(log.amount) < 0 ? "text-danger" : "text-success")
                                                }
                                            >
                {log.amount}
              </span>
                                        </div>

                                        <div className="d-flex justify-content-between">
                                            <span className="text-muted">Balance</span>
                                            <span className="ms-2">{log.balance_state}</span>
                                        </div>

                                        <div className="mt-1">
                                            <div className="text-muted">Description</div>
                                            <div className="text-break">{log.description}</div>
                                        </div>

                                        <div className="d-flex justify-content-between mt-1">
                                            <span className="text-muted">Created</span>
                                            <span className="ms-2 text-nowrap">
                {new Date(log.createdAt).toLocaleString('en-GB', {
                    day: '2-digit',
                    month: 'short',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: false
                })}
              </span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={internalhandleClose}>
                    Close
                </Button>
              </Modal.Footer>
            <ImageLightbox
                src={fullImage}
                alt="Full size proof image"
                onClose={() => setFullImage(null)}
            />
        </Modal>
    );
};

export default EditAssignmentAdmin;
